webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @author  lijiancheng | lijiancheng@17guagua.com
 * @version 1.0 | 2015/10/9
 * @js作用说明 cookie相关操作
 * @param 参数说明
 * @example  使用示例
 */

/* harmony default export */ __webpack_exports__["a"] = ({
    loginKey: { //登陆cookie项
        accessToken: true,
        channelid: true,
        hasLogin: true,
        isNew: true,
        lgtime: true,
        loginType: true,
        mcheck: true,
        nick: true,
        oemid: true,
        openid: true,
        openkey: true,
        refreshToken: true,
        regTime: true,
        sourceType: true,
        uid: true,
        unionid: true,
        webToken: true,
        sessionid: true,
        port: true,
        streamID: true,
        tempid: true,
        tempmcheck: true,
        photo: true
    },
    set: function set(cookieKey, cookieValue, cookieOpts) {
        if (sessionStorage.getItem('isxiaoxiong') == 'true' && this.loginKey[cookieKey]) {
            cookieKey = 'DL' + cookieKey;
        }
        var arr = [];
        var d, t;
        var cfg = {
            'expire': null,
            'customExpire': null,
            'path': null,
            'domain': null,
            'secure': null,
            'encode': true
        };
        $.extend(cfg, cookieOpts);

        //      if (cfg.encode == true) {
        cookieValue = encodeURI(cookieValue);
        //      }
        arr.push(cookieKey + '=' + cookieValue);

        if (cfg.path != null) {
            arr.push('path=' + cfg.path);
        }
        if (cfg.domain != null) {
            arr.push('domain=' + cfg.domain);
        }
        if (cfg.secure != null) {
            arr.push(cfg.secure);
        }
        if (cfg.expire != null) {
            d = new Date();
            t = d.getTime() + cfg.expire * 3600000; //cfg.expire * 1小时
            d.setTime(t);
            arr.push('expires=' + d.toGMTString());
        }
        if (cfg.customExpire != null) {
            arr.push('expires=' + cfg.customExpire.toGMTString());
        }

        document.cookie = arr.join(';');
    },
    get: function get(cookieKey) {
        //      cookieKey = cookieKey.replace(/([\.\[\]\$])/g, '\\\$1');
        //      var rep = new RegExp(cookieKey + '=([^;]*)?;', 'i');
        //      var co = document.cookie + ';';
        //      var res = co.match(rep);
        //      if (res) {
        //      		 return decodeURI(res[1])|| "";
        //      }
        //      else {
        //          return null;
        //      }
        if (sessionStorage.getItem('isxiaoxiong') == 'true' && this.loginKey[cookieKey]) {
            cookieKey = 'DL' + cookieKey;
        }
        var cookieKey = cookieKey.replace(/([\.\[\]\$])/g, '\\\$1');
        //var rep = new RegExp('(^;|)'+cookieKey + '=([^;]*)?;', 'ig');
        var rep = new RegExp("(^| )" + cookieKey + "=([^;]*)(;|$)", 'ig');
        var res = document.cookie.match(rep);
        if (res) {
            return decodeURI(res[0].replace(';', '').split('=')[1] || "");
        } else {
            return null;
        }
    },
    remove: function remove(cookieKey, cookieOpts) {
        if (sessionStorage.getItem('isxiaoxiong') == 'true' && this.loginKey[cookieKey]) {
            cookieKey = 'DL' + cookieKey;
        }
        cookieOpts = cookieOpts || {};
        cookieOpts.expire = -10;
        this.set(cookieKey, '', cookieOpts);
    }
});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-87d9c56c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(122),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51327a46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie__ = __webpack_require__(0);
/**
 * Created by 11789 on 2017/5/24.
 * @discription  WEB直播间的通行证
 * @parameter
 * @example
 */



/* harmony default export */ __webpack_exports__["a"] = ({
	isLogin: function isLogin() {
		//TODO 校验是否已经登录
		if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get('uid') && __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get('accessToken') && __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get('openid')) {
			return true;
		} else {
			return false;
		}
	},
	loginout: function loginout() {
		// 用户登出
		$.publish(config.Event_Type.loginOut); // 广播出去
	},
	loginJump: function loginJump() {
		var roomid = 0;
		window.location = 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100717093&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3fjumpUrl%3dhttp%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fweblivelogin%26roomid%3d' + roomid + '%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info';
	},
	getUserInfo: {
		accessToken: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("accessToken"),
		isNew: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("isNew"),
		lgtime: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("lgtime"),
		mcheck: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("mcheck"),
		nick: decodeURIComponent(__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("nick")),
		openid: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("openid"),
		refreshToken: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("refreshToken"),
		uid: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uid"),
		webToken: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("webToken")
	}
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmZDI1YTM0NC1kNmVjLTQzYjQtOWNmNS1mMTE3Y2ZiYjQ4OWIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzBDMjk1OTExMUFCMTFFQUFDNTI5RTBBRkREQ0YzN0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzBDMjk1OTAxMUFCMTFFQUFDNTI5RTBBRkREQ0YzN0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZDI1YTM0NC1kNmVjLTQzYjQtOWNmNS1mMTE3Y2ZiYjQ4OWIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6ZmQyNWEzNDQtZDZlYy00M2I0LTljZjUtZjExN2NmYmI0ODliIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+XdoaRwAAAN9JREFUeNqckj0KwkAUhDerYCobRWJjoVWK2Kgn0FNYip5Ka08RT6A2prCLYOMP2lil0TgPZmGRBBIHPsi+nXnZvKyTpqmiKmAIAtBi7Q4isANvKTgM1MEUeCpbV7AGLwlI5wXNTxCCmMYumIAGQ6sqj2HMS5BYnY/gBOb0DDTPrNg5yTiO1DZ8DiTQ5iJW+TJ7nlbFZEb5kcDF+sA89cyYNecsGgM3w+xyTxRJYM+RNTleH9SIz5rs3cT714+zr8YI9NlR9AAHsP29GoWlVUmVDshdmoFOQf+59Bu+AgwAe2Y8YgewEgIAAAAASUVORK5CYII="

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoyZWZiNzVmMC01ZTg2LTQ1MWUtOWJhNy0wODVjNGJiYzhhMzciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTJDN0MyQkUxMjU2MTFFQThBNzZFRTJGMEI4RjJCOTQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTJDN0MyQkQxMjU2MTFFQThBNzZFRTJGMEI4RjJCOTQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyZWZiNzVmMC01ZTg2LTQ1MWUtOWJhNy0wODVjNGJiYzhhMzciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MmVmYjc1ZjAtNWU4Ni00NTFlLTliYTctMDg1YzRiYmM4YTM3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+uXuduQAAAeBJREFUeNrs180rBGEcB/AZKWxy2NrykouDtKVot/YkbRStgxQXFzdtdg9bctiSHGz8AQ5ukhtpEQfJlk1ONn+AEmpZedtEKBnfh2f1eDy7Zmb3mb3sU5/amX1mnu/zm+eZGkXTNMUkJyxDmlqCFrP3MxtiDB60v+0O/FYEccOu9n/bgXYZQVSYhHtuwEcIwTg8cf/dQriQQTywJ5h1DNq4asWzVMedTxAbTMMrd+MbmMhRubCgcs8wBZVGg3jhQDC7da4K2bhgW3D9PnTqCVIDs/AieN6jBhd2GQTp1uarMwPV2YJ0w7FgFqv5vB+gFaKC+yZo5X+COGBO0PHCRBVyCUBSME4E7KTDoeDPFWgqYIiMZlgTjBdXuBMnMCwhAG8ETtmBFW4x+SwIkdHHjJsuU363a8W6dsUe8EGqLAxiyxWkaK0UpBSkFMRoKzdxjRfsOvqdw5GsIAGY19n3DXwQk/Fougz0rQCPrIpEwAGNOvomYFFWEHLzDlm7RmWOPyzcKOxYKgmi5bmLCrFj30mQJHNiwMIgQ8zvFEm1CU56IkRLtiHxMZHJ90OQObdFvszq6SKsLdJLNQUuku4Seumb0Op2Bj0kg/r1cfPdGsAPg1AnebeQdRmFBVoI5VOAAQBIOND31Jz/qwAAAABJRU5ErkJggg=="

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAJoUlEQVR4Xu1bvW8TWxa/Z/yBaCAUBFHEsSWCBArapCDhFQuZKmnA44YIrVYba7Elqpf8BRv/BSRVJHuf7LzVKoTGGSgg1dhs8UIokigIpLhIHAqEKEigQPjrrI6x8zwz986Mx3nO09ObMrlf53fP/Z3fueca2Al8nz596imXy/9ijE0h4oEkSZnz588nTmApDE5i0g8fPqwAQNgw93xvb+90t9fTdQAau/+JZ2hvb2/X19P1CT9+/DiGiNofAoB3796RMf9gjB0AgNrX15ezc+HjACCVStXnBYADxpgai8Vs5xWty7UH7O/vTzHG0oaBo4FAIGMFQqcAJJPJKQDQzQsAkfv376/Ygc/7v2sAisUi7frZ1kGJ0c+cORM6d+4c7Qz36wSAhYWFoNfr3TUOjIh78Xg81DUAGq7PPccAMN/X1ydk804ASCaTOQC4xTM0Fou52kxXnWgBPA9oLszn84UuXry4x1uoWwDo3DPGuKDTcmKxWLBrHtAAYBYASMzwvlwgEJCPGQACtF8w30wsFpvrKgAUzz9//rxn5IGWRUQCgYCJmNx4QCqVoiP1kGcgIm7F4/EhN8ZTH9dHgDoLIkF9LURM/f39JmJqF4B0Ot1TqVSI+HoERsonEgabi9nf399kjP1FsDuJ/v7+2db/tQtAMpmcA4AfBcaTBlDc7n7HHkADWEUEXli0kMKHvb29ul1OJpNDALAhMrBSqYQePHjAJVunoHCPwM7ODk181uv1boVCIWFMb/ECEj+kCE0fLyzykiFETFy4cEHnLalUijjEmDQ150jEYjFde+Pk6WRyCBk7Cz7fVjQa5dphAqBQKBgnnfV6vfNWQLx//z5YKpU2BYS4FQgEdCTV8IJZRFRIziLiitF4MiaVSqHgaB36fL6gyCgyvArwEBij0EnfAUOc+Wc8blKpOgAKhYKIbUn1TV+6dGlR5FrFYlEUFvOBQKC5EKeeWW+XTCZNarNBsNE4xxgizFq5/JABkEw3fZLXe84ImhEASiq4SqsxMe3yzMDAgCn5oF398uUL/d1IiLb5gQiVVCpFLq7TGoiYj8fjJkB/+t6WyFIULRhycgYjAFZn7midiJjx+XyJUCikIyA6CuVymQRJGBEPyWvskiM7l6AoQDdHjeO16PV6p1t3kRSihJhmALZKsMaYKWQaAbCSm8a1EqnM2fGDnYFu/59eWAhWvd50yzm3HAoZK97nyGUTCe7s7BDahLou0xONjoibPp9PdhIt3Bpr7PdTMjnFAEgZCt1d1wcxL/l8Co80uWFwd3e3p1qtEkuLBIhhfFy8fPkyl3iOy+jmOHWis1aGvx5VxoqAOMtj/2YjSym8u7sbrFQqFDqExNgYKD8wMOCK6dsFqH7mxVlhfbgG/8xJXu+cKFQ6AqDZqFAokHEEhCgbUwcGBjqSpE6BoLNf41yKNPsjY6qnUpmOOlSIbSVDhUKBQg1pBSM/yLzQ6NSodtv9O5XKgFF5Im7VAKbbTYzaAoAW2sIPpO7qkaCbxjfBqsd9xOaxy1idcyuA2wag3d36vbf/EwDaoe3tbXKlHwHAUVylNJcxNn/t2jXX9/HH6Rn/SacVFN8Z8KY68CAm/haNbsKbN2+UWq2WdbMgSZIiV69edXUf72Y+Xp/FdNrqbtJyGg/iMGxvbwuvmh0scnNwcHDYQbvfrMnPmQw3ZXY0IaJKAHBTTkcDMMYGBwdPlEc6BCAPr1+/dpQBCgBRBwcHuyKARBvyczq9xwBEAs1yH+kWCt6+fRusVqtEZu0OUvR4PGNXrlzp6E7OqaeJ2v03nR6qMpZjhjKd7biIW1XGxuruS+Lm69evY9Vq1dH9usfj2Tx9+nSumxmglUGUIHkYU5Ax2zsBGkdibPPv0WidvE/0/NruUhca/AlAF0D+XU/Rtgds/PJLsCRJdOWsUPmLAcyMjo52VQxls9meb9++PQQAWgOF8Yzf75+PRCK2NQzjbjgGYGNj4/vTNkRT7R8Zi3QThOXlZdPtNW0GAMxOTk4Kr+55rugIgFdra9P4vRTOzRUQUR29caMremBpaSkoSZLplUjTOETMUXy/d++eozzFEoBXr16N1arVNNhfOedHRke7ciW2tLQ0JkmS6KHE0SbT1f2pU6dm7I4FF4DWc+6EwZCxxOjoqGWdzsk4Tts8evSI3N2JcKtf2ExOTgpfoZoAWF9fn2JUaHD+5X1+vzI8PNw2ATmfQt/y8ePHQ+TqbVzd71HmevfuXSrl6z4dAG0af8gApkdGRiyfxbk10q4fRYJSqUT1C25VmtP/wO/3h4xHQg/Ay5eWtcEjomEs4ff757q56yJAGt5AQNhd3bNarSYbyVEHwMu1Nd4j5lZiUf2I08M//MBNgDRN64HvFRsixD0Jcf6mLHekEZ4+fapUq9V60RMAVmq1GjfeLy8vkyag1yRW3BCZnJzUrcfREUDEouTxTF2/ft0ytOQ0jarHuuowIEbcgqCqKq86vKIoSoTnEY1jQTqFd3V/6Pf7g5ZHgAZdX1ubY7/erx1Saen6jRu2T9BeaBppBfNLLsT8LVnWhUjylIaSa5bT5vx+f0KWZR2RrqyscC9ryJUjkYhwMxpagcCr80N9AyVJsSXBVlTX19eHRkZGTKzJQ77h+rvAEUr0jG1MlnVp9urqKk/JzU9MTOhUpqqqohcie4qi2D6NJY8ol8tBnuFNOxwpQTtGzmtaq9fomyMu3pLlo8IpgVUqlbi/FxgfH9etR1VVyzdC4XC4Y+3RMQCapg1JFi+5aoghWZaPSPPZs2dCJWcEIJvNCttSEoSIprBmt1mukyHRwHlNo+sofghCTNySZd0utQMAzamqqvAFGmNsMRwOd1SW78gDXmgaFSS4NQUqUdMVlZHY2gUgm80GAUD0Ao1i+3AkEnHEVa6zQdHu5zRNqMkBMXpTlk0qsV0AGl5gCodHogwxpygK92G2k+Pg2gPymjbLRK/FOaGvuRg3ABCbN7yAK3IAIHrnzh1Xktw1ADlNExZUJET5r7LMjdNuACDwnjx5Qr8x5CZp9E5JURRXFSpXAPxP08ZqAPyc3BD2jG7oFoDGURDmKuFw2JUtrjpRLJcATLG8QXxDrWHvOAHIZrNDkiSZHk/TvIqiOKpsH1sY5IkfQJy5KcuWsrkTD2h4AY2ve712IhxAi3mhaVPIGMXhA2As4yTp6RSAFj6oz0u/O759+7brjNPVEXASXkRtLKTw4fj4uCs37mQ9XQeAFvv8+XPer0AS4+PjHWv7dsE4EQBokaurq2RsPU2m3wtMTEzYptztGuek/f8Bg5iQDIClMm4AAAAASUVORK5CYII="

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//rem计算
/* harmony default export */ __webpack_exports__["a"] = ({
	init: function init(e) {
		if (!-[1]) {
			return false;
		} //判断是否IE浏览器
		function t() {
			var width = html.getBoundingClientRect().width;
			width / o > 750 && (width = 750 * o), window.rem = width / 15, html.style.fontSize = window.rem + "px";
		}
		var o,
		    i,
		    timer,
		    document = window.document,
		    html = document.documentElement,
		    meta = document.querySelector('meta[name="viewport"]');
		if (meta) {
			var d = meta.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
			d && (i = parseFloat(d[2]), o = parseInt(1 / i));
		} else meta = document.createElement("meta"), meta.setAttribute("name", "viewport"), meta.setAttribute("content", "width=device-width, initial-scale=1, user-scalable=no, minimal-ui"), html.firstElementChild.appendChild(meta);
		window.addEventListener("resize", function () {
			clearTimeout(timer), timer = setTimeout(t, 300);
		}, !1), window.addEventListener("pageshow", function (window) {
			window.persisted && (clearTimeout(timer), timer = setTimeout(t, 300));
		}, !1), "complete" === document.readyState ? document.body.style.fontSize = 12 * o + "px" : document.addEventListener("DOMContentLoaded", function () {
			document.body.style.fontSize = 12 * o + "px";
		}, !1), t();
	}
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dating_index__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dating_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dating_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dating_center__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dating_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dating_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dating_recharge__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dating_recharge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dating_recharge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dating_pay__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dating_pay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dating_pay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dating_search__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dating_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dating_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dating_care__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dating_care___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dating_care__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dating_paySucc__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dating_paySucc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_dating_paySucc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dating_bindPhone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dating_bindPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_dating_bindPhone__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_dating_index___default.a
  }, {
    path: '/center',
    name: 'center',
    component: __WEBPACK_IMPORTED_MODULE_3__components_dating_center___default.a
  }, {
    path: '/recharge',
    name: 'recharge',
    component: __WEBPACK_IMPORTED_MODULE_4__components_dating_recharge___default.a
  }, {
    path: '/pay',
    name: 'pay',
    component: __WEBPACK_IMPORTED_MODULE_5__components_dating_pay___default.a
  }, {
    path: '/search',
    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_6__components_dating_search___default.a
  }, {
    path: '/care',
    name: 'care',
    component: __WEBPACK_IMPORTED_MODULE_7__components_dating_care___default.a
  }, {
    path: '/paySucc',
    name: 'paySucc',
    component: __WEBPACK_IMPORTED_MODULE_8__components_dating_paySucc___default.a
  }, {
    path: '/bindPhone',
    name: 'bindPhone',
    component: __WEBPACK_IMPORTED_MODULE_9__components_dating_bindPhone___default.a
  }]
}));

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		curview: '',
		orderRmb: 0,
		searchRoomId: '',
		isLogin: false,
		channelID: '',
		sourceType: '',
		tips: '',
		forceLogin: false,
		isYouxi: false
	},
	mutations: {
		getCurview: function getCurview(state, data) {
			state.curview = data;
		},
		getOrderRmb: function getOrderRmb(state, data) {
			state.orderRmb = data;
		},
		getSearchRoomId: function getSearchRoomId(state, data) {
			state.searchRoomId = data;
		},
		getIsLogin: function getIsLogin(state, data) {
			state.isLogin = data;
		},
		getChannelID: function getChannelID(state, data) {
			state.channelID = data;
		},
		getSourceType: function getSourceType(state, data) {
			state.sourceType = data;
		},
		getTips: function getTips(state, data) {
			state.tips = data;
		},
		getForceLogin: function getForceLogin(state, data) {
			state.forceLogin = data;
		},
		isYouxi: function isYouxi(state, data) {
			state.isYouxi = data;
		}
	}
}));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(123),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_cookie__ = __webpack_require__(0);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	beforeMount: function beforeMount() {
		var xiaoxiongChannel = [731100001, 731100002, 731300001, 731300003];
		var channelid = this.querystr('channelid') || __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get('channelid') || 0;
		if (xiaoxiongChannel.indexOf(channelid - 0) != -1) {
			__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('isxiaoxiong', true, {
				domain: 'qxiu.com',
				encode: true
			});
			__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('oemid', 43, { domain: 'qxiu.com', encode: true });
			sessionStorage.setItem('isxiaoxiong', true);
		} else {
			__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('isxiaoxiong', false, {
				domain: 'qxiu.com',
				encode: true
			});
			sessionStorage.setItem('isxiaoxiong', false);
		}
	},

	methods: {
		querystr: function querystr(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		}
	}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "index",
    data: function data() {
        return {
            phone: "", //手机号
            yzImg: "", //图形码
            code: "", //验证码
            password: "", //密码
            phoneState: false, //手机校验
            yzImgState: false, //图形码校验
            codeState: false, //验证码校验
            passwordState: false, //密码校验
            tips: "",
            popTips: false,
            yzImgSrc: "https://login-m.qxiu.com/verify/codeImage?size=200x70",
            timer: true,
            timerstr: "获取验证码",
            hasBindPhone: ""
        };
    },

    components: {
        navtop: __WEBPACK_IMPORTED_MODULE_0__dating_navTop___default.a
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(["channelID", "sourceType", "forceLogin"]),
    mounted: function mounted() {
        this.checkBind();
    },

    methods: {
        checkBind: function checkBind() {
            var _this = this;
            $.ajax({
                type: "get",
                url: "https://login-m.qxiu.com/cgi/login/listbinds?oemid=43&uid=" + __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get("uid") + "&mcheck=" + __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get("mcheck"), //小熊版本oemid必填
                async: true,
                dataType: "jsonp",
                success: function success(res) {
                    if (res.state == 0 && res.content) {
                        for (var i = 0; i < res.content.length; i++) {
                            if (res.content[i].bindType == "phone") {
                                _this.hasBindPhone = res.content[i].bindId.slice(3);
                            }
                        }
                    } else if (res.message) {
                        toast(res.message);
                    }
                }
            });
        },
        toChangePhone: function toChangePhone() {
            toast("请下载小熊直播客户端 <br>更改绑定手机号");
        },
        getCode: function getCode() {
            var _this = this;
            if (!this.timer) {
                return;
            }
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                toast("请输入正确的手机号");
                return;
            } else if (!/^[\d a-z A-Z]{4}$/.test(this.yzImg)) {
                toast("请输入正确的图形验证码");
                return;
            } else {
                _this.yzImgSrc = _this.yzImgSrc + "&v=" + Math.random();

                $.ajax({
                    type: "get",
                    url: "https://login-m.qxiu.com/cgi/web/login/phone/sendCode?oemid=43&phone=" + _this.phone + "&code=" + _this.yzImg.toUpperCase(), //小熊版本oemid必填
                    async: true,
                    dataType: "jsonp",
                    success: function success(res) {
                        if (res.state == 0 && res.content.sendState == true) {
                            var time = 60;
                            _this.timer = false;
                            var interval = setInterval(function () {
                                _this.timerstr = time + "s";
                                time--;
                                if (time == 0) {
                                    clearInterval(interval);
                                    _this.timer = true;
                                    _this.timerstr = "获取验证码";
                                }
                            }, 1000);
                            toast("验证码发送成功");
                        } else if (res.message) {
                            toast(res.message);
                        }
                    }
                });
            }
        },
        toBind: function toBind() {
            var _this = this;
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                toast("请输入正确的手机号");
                return;
            } else if (!/^\d{6}$/.test(this.code)) {
                toast("请输入正确的短信验证码");
                return;
            } else if (!/^[\d a-z A-Z \- \. \/]{6,}$/.test(this.password)) {
                toast("请输入正确的密码");
                return;
            } else {
                $.ajax({
                    type: "get",
                    url: "https://login-m.qxiu.com/cgi/login/bindPhone?oemid=43&uid=" + __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get("uid") + "&mcheck=" + __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get("mcheck") + "&phone=" + _this.phone + "&code=" + _this.code + "&password=" + _this.password + "&thirdNick=" + _this.phone, //小熊版本oemid必填
                    async: true,
                    dataType: "jsonp",
                    success: function success(res) {
                        if (res.state == 0) {
                            toast("绑定成功", function () {
                                _this.checkBind();
                            });
                        } else if (res.state == 200501) {
                            toast("您输入的手机号已绑定或注册请更换手机号");
                        } else if (res.message) {
                            toast(res.message);
                        }
                    }
                });
            }
        }
    },
    watch: {
        phone: function phone() {
            if (this.phone.length > 11) {
                this.phone = this.phone.slice(0, 11);
            }
            if (/^1[234578]\d{9}$/.test(this.phone)) {
                this.phoneState = true;
            } else {
                this.phoneState = false;
            }
        },
        yzImg: function yzImg() {
            if (/^[\d a-z A-Z]{4}$/.test(this.yzImg)) {
                this.yzImgState = true;
            } else {
                this.yzImgState = false;
            }
        },
        code: function code() {
            if (/^\d{6}$/.test(this.code)) {
                this.codeState = true;
            } else {
                this.codeState = false;
            }
        },
        password: function password() {
            if (/^[\d a-z A-Z \- \. \/]{6,}$/.test(this.password)) {
                this.passwordState = true;
            } else {
                this.passwordState = false;
            }
        }
    }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dating_navBottom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dating_navBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dating_navBottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_cookie__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			navBott: 1,
			attentList: '',
			onlingAttentList: [],
			recomList: '',
			scrollHeight: '',
			protocol: location.protocol
		};
	},

	components: {
		navtop: __WEBPACK_IMPORTED_MODULE_0__dating_navTop___default.a,
		navbottom: __WEBPACK_IMPORTED_MODULE_1__dating_navBottom___default.a
	},
	computed: {
		channelid: function channelid() {
			return __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid');
		}
	},
	mounted: function mounted() {
		var _this = this;
		$.ajax({
			type: "get",
			url: "https://hot-active.qxiu.com/hallhome/recommend/getAttentionRecommendWeb?userId=" + __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('uid') + "&openid=" + __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('openid') + "&openkey=" + __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('accessToken'),
			async: true,
			dataType: "jsonp",
			success: function success(res) {
				if (res.result.infos) {
					_this.attentList = res.result.infos;
					for (var i = 0; i < _this.attentList.length; i++) {
						if (_this.attentList[i].isOnline != 0) {
							_this.onlingAttentList.push(_this.attentList[i]);
						}
					}
				}
			}
		});
		$.ajax({
			type: "post",
			url: "https://hot-active.qxiu.com/hallhome/mobile/getMobileAnchorRank?tag=1",
			async: true,
			dataType: "jsonp",
			success: function success(res) {
				_this.recomList = res.result.anchors[0].list.slice(0, 9);
			}
		});

		var height = document.documentElement.clientHeight;
		this.scrollHeight = height / parseInt($('html').css('font-size')) - 2 + 'rem';
	}
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_nobility__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_nobility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libs_nobility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_passport__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dating_navBottom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dating_navBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dating_navBottom__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'center',
	data: function data() {
		return {
			navBott: 2,
			qiqidou: 0,
			leval: '',
			fixednick: false,
			uNick: '',
			baseInfo: {
				nick: __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('nick'),
				uid: __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('uid')
			},
			kefuQQ: false,
			saveNick: false,
			logoutTips: false,
			nickTipsCon: '',
			nickTips: false,
			showYe: true
		};
	},

	components: {
		navtop: __WEBPACK_IMPORTED_MODULE_6__dating_navTop___default.a,
		navbottom: __WEBPACK_IMPORTED_MODULE_7__dating_navBottom___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		userImg: function userImg() {
			if (__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo') && __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo') != 'null' && __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').indexOf('static.qxiu.com') == -1) {
				if (__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').slice(0, 1) == '"') {
					return 'https://qiqi-resource-v6.qxiu.com' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').slice(1, -1).slice(29);
				} else {
					return 'https://qiqi-resource-v6.qxiu.com' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').slice(29);
				}
			} else {
				if (this.isxiaoxiong) {
					return 'https://static.qxiu.com/h5/static/xiaoxiong.png';
				} else {
					return 'https://static.qxiu.com/h5/static/img/app.png';
				}
			}
		},
		curScore: function curScore() {
			if (__WEBPACK_IMPORTED_MODULE_2__libs_nobility___default.a.levelObj[this.leval.nobility]) {
				return this.leval.score - __WEBPACK_IMPORTED_MODULE_2__libs_nobility___default.a.levelObj[this.leval.nobility].get_score;
			}
		},
		totalScore: function totalScore() {
			var _totalScore = __WEBPACK_IMPORTED_MODULE_2__libs_nobility___default.a.levelObj[this.leval.nobility];
			if (_totalScore) {
				return _totalScore.totalScore;
			}
		},
		isHideLogout: function isHideLogout() {
			var channel = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('channelid');
			return channel != 54 && channel != 55 && channel != 10102;
		},
		isxiaoxiong: function isxiaoxiong() {
			return __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('isxiaoxiong') == 'true';
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['isYouxi']), {
		authCode: function authCode() {
			return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('authCode') || '未获取到authCode';
		}
	}),
	mounted: function mounted() {
		if (!__WEBPACK_IMPORTED_MODULE_5__libs_passport__["a" /* default */].isLogin()) {
			this.$store.commit('getCurview', '');
			location.hash = "/";
		}
		var _this = this;

		var u = navigator.userAgent,
		    isGooglePlay = !!u.match(/_GM_/); //googlePlay手Q终端
		if (isGooglePlay) {
			this.showYe = false;
		}
		$.ajax({
			type: "get",
			url: "https://api-live.qxiu.com/webProxy/cgi/webQiQiDouQuery?userId=" + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('uid') + '&meck=' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('mcheck'),
			async: true,
			dataType: "jsonp",
			success: function success(res) {
				_this.qiqidou = res.result.qiqidou;
			}
		});
		$.ajax({
			type: "get",
			url: "https://account.qxiu.com/nobility/getNobilityAndScoreByUid?uid=" + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('uid') + '&meck=' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('mcheck'),
			async: true,
			dataType: "jsonp",
			jsonp: "callbackname",
			success: function success(res) {
				if (res && res.code == 0) {
					_this.leval = res.rs;
				}
			}
		});
	},

	methods: {
		subNick: function subNick() {
			if (this.uNick) {
				if (this.uNick.length > 8) {
					this.nickTips = true;
					this.nickTipsCon = "昵称不能超过8个汉字";
					return false;
				} else if (this.uNick.indexOf(" ") != -1) {
					this.nickTips = true;
					this.nickTipsCon = "昵称不能包含空格";
					return false;
				}
				var _this = this;
				_this.uNick = _this.uNick.length > 8 ? _this.uNick.slice(0, 8) : _this.uNick;
				$.ajax({
					type: "get",
					url: "https://api-live.qxiu.com/webProxy/cgi/webUpUserInfo",
					dataType: "jsonp",
					data: {
						userId: _this.baseInfo.uid,
						nickname: _this.uNick
					},
					async: true,
					success: function success(res) {
						if (res.result.state == 0) {
							_this.fixednick = !_this.fixednick;
							__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].set('nick', _this.uNick, {
								domain: 'qxiu.com',
								encode: true
							});
							_this.baseInfo.nick = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('nick');
						}
					}
				});
			} else {
				this.nickTips = true;
				this.nickTipsCon = "昵称不能为空";
			}
		},
		cancelSubNick: function cancelSubNick() {
			this.fixednick = false;
			this.uNick = '';
		},
		logout: function logout() {
			this.logoutTips = true;
		},
		confirmLogout: function confirmLogout() {
			this.logoutTips = false;
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('uid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('accessToken', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('openid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('webToken', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('refreshToken', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('mcheck', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('pgv_pvi', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('closedownLoad', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('tempid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('tempmcheck', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('wxopenid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('bindPhone', { domain: 'qxiu.com' });
			location.hash = '/';
		},
		toCharge: function toCharge() {
			if (!__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('wxopenid') && this.isWeixin()) {
				//					location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3d"+ location.protocol.slice(0,-1) +"%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
				location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
			} else {
				location.hash = "#/recharge";
			}
		},
		toMycare: function toMycare() {
			location.hash = "#/care";
		},
		toBindPhone: function toBindPhone() {
			location.hash = "#/bindPhone";
		},
		isWeixin: function isWeixin() {
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		}
	},
	watch: {
		uNick: function uNick() {
			if (!this.uNick) {
				this.saveNick = true;
			} else {
				this.saveNick = false;
			}
		}
	}
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_passport__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_webLog__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dating_navBottom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dating_navBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__dating_navBottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dating_phoneLogin__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dating_phoneLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dating_phoneLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dating_loginMode__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dating_loginMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__dating_loginMode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dating_registmode__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dating_registmode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dating_registmode__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			navBott: 0,
			navIndex: 1,
			showList: '',
			lazyImg: 10, //懒加载
			searchShow: false, //搜索框
			searchId: '', //房间号搜索
			popTips: false,
			loadingImg: false,
			scrollHeight: '',
			loadingMore: false,
			timmer: null,
			countDown: false, //滚动回调事件禁止倒计时内
			isAndroid: false,
			isShowTgy: false
		};
	},

	components: {
		navtop: __WEBPACK_IMPORTED_MODULE_5__dating_navTop___default.a,
		navbottom: __WEBPACK_IMPORTED_MODULE_6__dating_navBottom___default.a,
		phonelogin: __WEBPACK_IMPORTED_MODULE_7__dating_phoneLogin___default.a,
		loginmode: __WEBPACK_IMPORTED_MODULE_8__dating_loginMode___default.a,
		registmode: __WEBPACK_IMPORTED_MODULE_9__dating_registmode___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		isxiaoxiong: function isxiaoxiong() {
			return __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('isxiaoxiong') == 'true';
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['curview', 'tips', 'isYouxi'])),
	mounted: function mounted() {

		var u = navigator.userAgent;
		this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端

		var channelid = __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid') || 0,
		    oemid = __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('oemid') || 201;
		if (this.querystr("channelid")) {
			channelid = this.querystr("channelid");
		}
		if (this.querystr("oemid")) {
			oemid = this.querystr("oemid");
		}
		this.$store.commit('getChannelID', channelid);
		__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('channelid', channelid, { domain: 'qxiu.com', encode: true });
		__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('oemid', oemid, { domain: 'qxiu.com', encode: true });

		if (this.querystr("sourceType")) {
			this.$store.commit('getSourceType', this.querystr("sourceType"));
		}
		if (__WEBPACK_IMPORTED_MODULE_3__libs_passport__["a" /* default */].isLogin()) {
			this.$store.commit('getIsLogin', true);
			if (!__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('photo') || __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('photo') == 'null' || __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('photo') == 'undefined') {
				if (this.isxiaoxiong) {
					__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('photo', "https://static.qxiu.com/h5/static/xiaoxiong.png", { domain: 'qxiu.com', encode: true });
				} else {
					__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('photo', "https://static.qxiu.com/h5/static/img/app.png", { domain: 'qxiu.com', encode: true });
				}
			}
		} else {
			this.$store.commit('getIsLogin', false);
		}

		//			if(sessionStorage.dtRecharge && cookie.get('uid')){
		//				sessionStorage.dtRecharge=''
		//				location.hash="/recharge"
		//			}
		if (channelid == 731100001 || channelid == 731100002) {
			this.$store.commit('isYouxi', true);
			if (!__WEBPACK_IMPORTED_MODULE_3__libs_passport__["a" /* default */].isLogin()) {
				this.toLoginYx(); //游戏登陆
			}
		} else {
			this.$store.commit('isYouxi', false);
		}

		var _this = this;
		$.ajax({
			type: "post",
			url: "https://hot-active.qxiu.com/hallhome/mobile/getMobileAnchorRank?tag=1",
			async: true,
			dataType: "jsonp",
			success: function success(res) {
				if (res.retcode == 0 && res.result.anchors) {
					var list = [];
					for (var i = 0; i < res.result.anchors.length; i++) {
						list = list.concat(res.result.anchors[i].list);
					}
					_this.showList = list;
				}
			}
		});
		_this.getSuperNewStar();

		$('.anchorList').on('scroll', function () {
			if (_this.showList.length - _this.lazyImg < 0) {
				return;
			}
			if ($('.anchorList ul').height() - $('.anchorList').height() - $('.anchorList').scrollTop() <= 300 && !_this.curview && !_this.loadingImg && _this.countDown == false) {
				_this.loadingMore = true;
				_this.countDown = true;
				var timer2 = setTimeout(function () {
					_this.loadingMore = false;
					_this.countDown = false;
					_this.lazyImg += 10;
					clearTimeout(timer2);
				}, 1500);
				clearTimeout(_this.timer);
				_this.timer = null;
			}
		});

		__WEBPACK_IMPORTED_MODULE_4__libs_webLog__["a" /* default */].PV();
		__WEBPACK_IMPORTED_MODULE_4__libs_webLog__["a" /* default */].dataReport();

		var height = document.documentElement.clientHeight;
		this.scrollHeight = height / parseInt($('html').css('font-size')) - 5 + 'rem';

		channelid = channelid - 0;
		if (100060001 <= channelid && channelid <= 100060006 || 100070001 <= channelid && channelid <= 100070054 || 100080001 <= channelid && channelid <= 100080014 || channelid == 10009) {
			if (!__WEBPACK_IMPORTED_MODULE_3__libs_passport__["a" /* default */].isLogin()) {
				_this.$store.commit('getCurview', 'loginmode');
				_this.$store.commit('getForceLogin', true);
			}
		}

		if (channelid == '505') {
			console.log(12312132);
			this.isShowTgy = true;
		}
	},

	methods: {
		toLoginYx: function toLoginYx() {
			//划水麻将游戏登陆
			var _this = this;
			__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('scheme', _this.querystr("scheme"), { domain: 'qxiu.com' });
			$.ajax({
				type: "post",
				url: "https://login-m.qxiu.com/cgi/partner/login?appid=leshi&code=" + _this.querystr("code") + "&area=" + _this.querystr("area") + "&scheme=" + _this.querystr("scheme") + "",
				async: true,
				dataType: "jsonp",
				success: function success(res) {
					if (res.state == 0 && res.content.uid) {
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('isNew', res.content.isnew, { domain: 'qxiu.com' });
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('mcheck', res.content.meck, { domain: 'qxiu.com' });
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('nick', res.content.nick, { domain: 'qxiu.com' });
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('openid', res.content.openid || 1, { domain: 'qxiu.com' });
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('accessToken', res.content.openkey || 1, { domain: 'qxiu.com' });
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('uid', res.content.uid, { domain: 'qxiu.com' });
						__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('photo', res.content.portrait, { domain: 'qxiu.com' });
						//							cookie.set('webToken', res.content.webToken, {domain: 'qxiu.com'})
						location.reload();
					}
				}
			});
		},
		getSuperNewStar: function getSuperNewStar() {
			var _this = this;
			//				获取超新星
			$.ajax({
				type: "post",
				url: "https://cgi-client.qxiu.com/hall/starAnchor/getRecList",
				async: true,
				dataType: "jsonp",
				success: function success(res) {
					if (res.state == 0 && res.content.list) {
						_this.showList = res.content.list.concat(_this.showList);
					}
				}
			});
		},
		querystr: function querystr(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		subString: function subString(str, len, hasDot) {
			if (null == str || undefined == str) {
				str = '';
			}
			str = str.replace(/&nbsp;/g, ' ');
			var newLength = 0;
			var newStr = "";
			var chineseRegex = /[^\x00-\xff]/g;
			var singleChar = "";
			var strLength = str.replace(chineseRegex, "**").length;

			for (var i = 0; i < strLength; i++) {
				singleChar = str.charAt(i).toString();
				if (singleChar.match(chineseRegex) != null) {
					newLength += 2;
				} else {
					newLength++;
				}
				if (newLength > len) {
					break;
				}
				newStr += singleChar;
			}
			if (hasDot && strLength > len) {
				newStr += "...";
			}
			return newStr;
		},
		checkLogin: function checkLogin(roomId) {
			//				if(passPort.isLogin()) {
			if (this.navIndex == 10) {
				location.href = location.protocol + "//h5.qxiu.com/roomFull.html?roomid=" + roomId + "&channelid=" + __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid');
			} else {
				location.href = location.protocol + "//h5.qxiu.com/room.html?roomid=" + roomId + "&channelid=" + __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid');
			}

			//				} else {
			//					this.$store.commit('getCurview', 'loginmode')
			//				}
		},
		searchRoom: function searchRoom() {
			this.popTips = false;
			var reg = /^[23478]\d{5}$/g;
			if (reg.test(this.searchId)) {
				this.$store.commit('getSearchRoomId', this.searchId);
				__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].set('searchRoomId', this.searchId, { domain: "qxiu.com" });
				location.hash = '/search?';
			} else {
				this.$store.commit('getTips', { con: '请输入以2/3/4/7/8开头的6位数字！' });
			}
		},
		showSearch: function showSearch() {
			this.searchShow = !this.searchShow;
		},
		confirmTips: function confirmTips() {
			if (this.tips.func) {
				this.tips.func();
			}
			this.$store.commit('getTips', '');
		},
		closeTips: function closeTips() {
			this.$store.commit('getTips', '');
		},
		isWeixin: function isWeixin() {
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		},
		download: function download() {
			var _this = this;
			var u = navigator.userAgent,
			    isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
			    //android终端
			isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
			    //ios终端
			channelid = __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid') > 0 ? __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid') : 10001;
			_hmt.push(['_trackEvent', "下载按钮", "click", '006']); //百度统计
			if (isiOS) {
				//					location.href = "https://apps.apple.com/cn/app/id1450233438?l=zh&ls=1"
				location.href = "http://ios.qxiu.com/LoveQiMiaoLive";
			} else {
				var downloadUrl;
				if (__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid') == 731300001) {
					downloadUrl = 'https://m.qxiu.com/download/qx/download.jsp?channelid=713&oemid=31';
				} else if (__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid') == 731300003) {
					downloadUrl = 'https://m.qxiu.com/download/qx/download.jsp?channelid=120&oemid=31';
				} else if (__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('channelid') == 740900023) {
					downloadUrl = 'http://c.img001.com/qxiu/QiQi506.apk';
				} else if (_this.isYouxi) {
					downloadUrl = 'qqzbdownload://m.qxiu.com/download/qx/download.jsp?channelid=700&oemid=31';
				} else {
					downloadUrl = 'https://m.qxiu.com/download/qx/download.jsp?channelid=' + channelid + "&oemid=" + (_this.isxiaoxiong ? 31 : 15);
				}

				if (isAndroid && this.isWeixin()) {
					_AP.pay(downloadUrl);
				} else {
					location.href = downloadUrl;
				}
			}
		},
		backGame: function backGame() {
			location.href = (__WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('scheme') || 'miaqiyx') + '://miaqiyx';
		},
		toRegist: function toRegist() {
			this.$store.commit('getCurview', 'registmode');
		}
	},
	watch: {
		navIndex: function navIndex() {
			var _this = this;
			_this.loadingImg = true;
			_this.showList = '';
			$.ajax({
				type: "post",
				url: "https://hot-active.qxiu.com/hallhome/mobile/getMobileAnchorRank?tag=" + this.navIndex,
				async: true,
				dataType: "jsonp",
				success: function success(res) {
					_this.lazyImg = 10;
					if (_this.navIndex == 1) {
						if (res.retcode == 0 && res.result.anchors) {
							var list = [];
							for (var i = 0; i < res.result.anchors.length; i++) {
								list = list.concat(res.result.anchors[i].list);
							}
							_this.showList = list;
						}
						_this.getSuperNewStar();
					} else {
						var reqIndex = /tag=(\d{1,2})/.exec(this.url.slice(this.url.indexOf('tag')))[1]; //获取请求的tagid
						if (reqIndex == _this.navIndex) {
							_this.showList = res.result.anchors;
						}
					}
					_this.loadingImg = false;
				}
			});
		}
	}
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			userImg: '',
			userNick: '',
			protocol: 'https' //location.protocol.slice(0,-1)
		};
	},
	mounted: function mounted() {
		if (__WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get("loginType") == "wechatGZH") {
			this.userImg = __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get('photo');
			this.userNick = __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get('nick');
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		isxiaoxiong: function isxiaoxiong() {
			return __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get('isxiaoxiong') == 'true';
		},
		hrefstr: function hrefstr() {
			var hrefstr = '';

			if (this.sourceType) {
				hrefstr += '%26sourceType%3D' + this.sourceType;
			}

			if (this.channelID) {
				hrefstr += '%26channelid%3D' + this.channelID;
			}

			return hrefstr;
		},
		wxLogin: function wxLogin() {
			return this.isWeixin();
		},
		isShowLogin: function isShowLogin() {
			return !(__WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get('channelid') == 55 || __WEBPACK_IMPORTED_MODULE_1__libs_cookie__["a" /* default */].get('channelid') == 10102);
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['channelID', 'sourceType', 'forceLogin'])),
	methods: {
		phoneLogin: function phoneLogin() {
			this.$store.commit('getCurview', 'phonelogin');
		},
		outPop: function outPop() {
			if (!this.forceLogin) {
				this.$store.commit('getCurview', '');
			}
		},
		isWeixin: function isWeixin() {
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		}
	}
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_passport__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_cookie__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'navBot',
	data: function data() {
		return {
			showLabel: true,
			showDown: true
		};
	},

	props: ['index'],
	computed: {
		isxiaoxiong: function isxiaoxiong() {
			return __WEBPACK_IMPORTED_MODULE_2__libs_cookie__["a" /* default */].get('isxiaoxiong') == 'true';
		}
	},
	mounted: function mounted() {
		var u = navigator.userAgent,
		    isGooglePlay = !!u.match(/_GM_/); //googlePlay手Q终端
		if (isGooglePlay) {
			this.showDown = false;
		}
	},

	methods: {
		toCare: function toCare() {
			if (__WEBPACK_IMPORTED_MODULE_1__libs_passport__["a" /* default */].isLogin()) {
				location.hash = "/care";
			} else {
				this.$store.commit('getCurview', 'loginmode');
			}
		},
		toCenter: function toCenter() {
			if (__WEBPACK_IMPORTED_MODULE_1__libs_passport__["a" /* default */].isLogin()) {
				location.hash = "/center";
			} else {
				this.$store.commit('getCurview', 'loginmode');
			}
		},
		loadDown: function loadDown() {},
		isWeixin: function isWeixin() {
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		},
		closeLabel: function closeLabel(e) {
			this.showLabel = false;
			e.stopPropagation();
		}
	}
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_passport__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_cookie__ = __webpack_require__(0);


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			showRecharge: true
		};
	},

	props: ['index'],
	computed: {
		userImg: function userImg() {
			if (!__WEBPACK_IMPORTED_MODULE_2__libs_passport__["a" /* default */].isLogin()) {
				return 'https://static.qxiu.com/h5/static/userDefault.png';
			} else if (__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo')) {
				if (__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').slice(0, 1) == '"') {
					return 'https://qiqi-resource-v6.qxiu.com' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').slice(1, -1).slice(29);
				} else if (__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo') == 'null' || __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').indexOf('static.qxiu.com') != -1) {
					if (this.isxiaoxiong) {
						return 'https://static.qxiu.com/h5/static/xiaoxiong.png';
					} else {
						return 'https://static.qxiu.com/h5/static/img/app.png';
					}
				} else {
					return 'https://qiqi-resource-v6.qxiu.com' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo').slice(29);
				}
			} else {
				return this.isxiaoxiong ? 'https://static.qxiu.com/h5/static/xiaoxiong.png' : 'https://static.qxiu.com/h5/static/img/app.png';
			}
		},
		userNick: function userNick() {
			return __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('nick');
		},
		isLogin: function isLogin() {
			return __WEBPACK_IMPORTED_MODULE_2__libs_passport__["a" /* default */].isLogin();
		},
		showRoomEntry: function showRoomEntry() {
			return this.querystr('roomid');
		},
		isxiaoxiong: function isxiaoxiong() {
			return __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('isxiaoxiong') == 'true';
		}
	},
	mounted: function mounted() {
		var u = navigator.userAgent,
		    isGooglePlay = !!u.match(/_GM_/); //googlePlay手Q终端
		if (isGooglePlay) {
			this.showRecharge = false;
		}
	},

	methods: (_methods = {
		querystr: function querystr(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.href.slice(window.location.href.indexOf('?')).substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		toCare: function toCare() {
			if (__WEBPACK_IMPORTED_MODULE_2__libs_passport__["a" /* default */].isLogin()) {
				location.hash = "/care";
			} else {
				this.$store.commit('getCurview', 'loginmode');
			}
		},
		toDating: function toDating() {
			if (this.showRoomEntry) {
				location.href = location.protocol + "//h5.qxiu.com/room.html?roomid=" + this.showRoomEntry + "&channelid=" + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('channelid');
			} else {
				location.hash = "/";
			}
		},
		toCenter: function toCenter() {
			location.hash = "/center";
		}
	}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'toCenter', function toCenter() {
		if (__WEBPACK_IMPORTED_MODULE_2__libs_passport__["a" /* default */].isLogin()) {
			location.hash = "/center";
		} else {
			this.$store.commit('getCurview', 'loginmode');
		}
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'toRecharge', function toRecharge() {
		if (__WEBPACK_IMPORTED_MODULE_2__libs_passport__["a" /* default */].isLogin()) {
			if (!__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('wxopenid') && this.isWeixin()) {
				//						location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3d"+location.protocol.slice(0,-1)+"%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
				location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
			} else {
				location.href = location.protocol + "//h5.qxiu.com/index.html#/recharge";
			}
		} else {
			var that = this;
			this.$store.commit('getTips', { con: '请在登录之后进行充值哦！', func: function func() {
					sessionStorage.dtRecharge = true;
					that.$store.commit('getCurview', 'loginmode');
				} });
		}
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDown', function loadDown() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'isWeixin', function isWeixin() {
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	}), _methods)
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dating_navBottom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dating_navBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dating_navBottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_ap__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_ap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__libs_ap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'pay',
	data: function data() {
		return {
			openBrowser: false
		};
	},

	components: {
		navtop: __WEBPACK_IMPORTED_MODULE_2__dating_navTop___default.a,
		navbottom: __WEBPACK_IMPORTED_MODULE_3__dating_navBottom___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		isxiaoxiong: function isxiaoxiong() {
			return __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('isxiaoxiong') == 'true';
		},
		isWx: function isWx() {
			return this.isWeixin();
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['orderRmb'])),
	methods: {
		pay: function pay(paytype) {
			var _this = this;
			if (paytype == 25) {
				//					_this.openBrowser = true
				_AP.pay("https://order.qxiu.com/v2/unifiedPayController/createOrder?userId=" + __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('uid') + "&payType=" + paytype + "&orderMoney=" + _this.orderRmb + "&openid=" + __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('openid') + "&tradeType=MWEB&oemId=" + (_this.isxiaoxiong ? 39 : 201) + "&channelId=" + __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('channelid'));
			} else {
				$.ajax({
					type: "get",
					url: "https://order.qxiu.com/v2/unifiedPayController/createOrder?userId=" + __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('uid') + "&payType=" + paytype + "&orderMoney=" + _this.orderRmb + "&openid=" + __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('wxopenid') + "&tradeType=JSAPI&oemId=" + (_this.isxiaoxiong ? 39 : 201) + "&channelId=" + __WEBPACK_IMPORTED_MODULE_4__libs_cookie__["a" /* default */].get('channelid'),
					async: true,
					dataType: 'jsonp',
					jsonp: 'callbackname',
					success: function success(res) {
						if (res.state != 0) {
							alert(res.message);
							return;
						}
						function onBridgeReady() {
							WeixinJSBridge.invoke('getBrandWCPayRequest', {
								"appId": res.content.tokenInfo.appId, //公众号名称，由商户传入     
								"timeStamp": res.content.tokenInfo.timeStamp, //时间戳，自1970年以来的秒数     
								"nonceStr": res.content.tokenInfo.nonceStr, //随机串     
								"package": res.content.tokenInfo.package,
								"signType": "MD5", //微信签名方式：     
								"paySign": res.content.tokenInfo.paySign //微信签名 
							}, function (res) {
								if (res.err_msg == "get_brand_wcpay_request:ok") {} // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
							});
						}
						if (typeof WeixinJSBridge == "undefined") {
							if (document.addEventListener) {
								document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
							} else if (document.attachEvent) {
								document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
								document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
							}
						} else {
							onBridgeReady();
						}
					},
					error: function error() {
						alert('创建订单失败');
					}
				});
			}
		},
		querystr: function querystr(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		isWeixin: function isWeixin() {
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		}
	}
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_cookie__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'paySucc',
	data: function data() {
		return {};
	},

	methods: {
		toRecharge: function toRecharge() {
			location.href = location.protocol + '//h5.qxiu.com/#/recharge' + (__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get('roomid') ? '?roomid=' + __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get('roomid') : '');
		}
	}
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



window.addEventListener("message", function (event) {
    console.log(event.data);
    // _this.getCodeReq(event.data);
});
/* harmony default export */ __webpack_exports__["default"] = ({
    name: "index",
    data: function data() {
        return {
            phone: "", //手机号
            code: "", //验证码
            phoneState: false, //手机校验
            codeState: false, //验证码校验
            tips: "",
            popTips: false,
            timer: true,
            timerstr: "获取验证码",
            iframeSrc: "",
            showIfr: false
        };
    },
    created: function created() {
        var _this = this;
        window.addEventListener("message", function (event) {
            console.log(event.data);
            _this.getCodeReq(event.data);
        });
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(["channelID", "sourceType", "forceLogin"]),
    methods: {
        outPop: function outPop() {
            if (this.forceLogin) {
                this.$store.commit("getCurview", "loginmode");
                return;
            }
            this.$store.commit("getCurview", "");
        },
        getCode: function getCode() {
            var _this = this;
            if (!(_this.phoneState & _this.timer)) {
                return;
            }
            _this.showIfr = true;
            _this.iframeSrc = "https://page.qxiu.com/verify/verify_slider.html?isweb=true&mobile=" + _this.phone;
        },
        getCodeReq: function getCodeReq(data) {
            var _this = this;
            _this.showIfr = false;
            $.ajax({
                type: "get",
                url: "https://login-m.qxiu.com/cgi/web/login/phone/sendCode?phone=" + _this.phone + "&verifyType=slider&orderCheckID=" + data,
                async: true,
                dataType: "jsonp",
                success: function success(res) {
                    if (res.state == 0 && res.content.sendState == true) {
                        var time = 60;
                        _this.timer = false;
                        var interval = setInterval(function () {
                            _this.timerstr = time;
                            time--;
                            if (time == 0) {
                                clearInterval(interval);
                                _this.timer = true;
                                _this.timerstr = "获取验证码";
                            }
                        }, 1000);
                        window.toast("验证码发送成功");
                    } else {
                        window.toast(res.message);
                    }
                }
            });
        },
        login: function login() {
            if (this.phoneState && this.codeState) {
                var _this = this;
                $.ajax({
                    type: "get",
                    url: "https://login-m.qxiu.com/cgi/web/login/phone?phone=" + _this.phone + "&code=" + _this.code + "&oemid=" + (__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get("oemid") || 201) + "" + (_this.sourceType ? "&sourceType=" + _this.sourceType : "") + (_this.channelID ? "&channelid=" + _this.channelID : ""),
                    async: true,
                    dataType: "jsonp",
                    success: function success(res) {
                        if (res.state == 0 && (res.content.openid || res.content.DLopenid)) {
                            if (__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get("isxiaoxiong") == "true") {
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("ip", res.content.DLip, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("isNew", res.content.DLisNew, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("isnp", res.content.DLisnp, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("mcheck", res.content.DLmeck, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("nick", res.content.DLnickname, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("openid", res.content.DLopenid, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("accessToken", res.content.DLaccessToken, { domain: "qxiu.com" });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("uid", res.content.DLuid, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("webToken", res.content.DLwebToken, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("photo", res.content.DLphoto, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("szNickMd5", res.content.DLszNickMd5, { domain: "qxiu.com" });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("ip", res.content.ip, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("isNew", res.content.isnew, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("isnp", res.content.isnp, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("mcheck", res.content.meck, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("nick", res.content.nickname, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("openid", res.content.openid, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("accessToken", res.content.openkey, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("uid", res.content.userid, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("webToken", res.content.webToken, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("photo", res.content.photo, {
                                    domain: "qxiu.com"
                                });
                                __WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set("szNickMd5", res.content.szNickMd5, {
                                    domain: "qxiu.com"
                                });
                            }
                            _this.$store.commit("getCurview", "");
                            location.reload();
                        } else {
                            window.toast(res.msg);
                        }
                    }
                });
            }
        },
        checkPhone: function checkPhone() {
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                alert("请输入11位正确的手机号");
            }
        },
        checkPhoneImg: function checkPhoneImg() {
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                alert("请输入11位正确的手机号");
            }
        }
    },
    watch: {
        phone: function phone() {
            if (/^1[234578]\d{9}$/.test(this.phone)) {
                this.phoneState = true;
            } else {
                this.phoneState = false;
            }
        },
        code: function code() {
            if (/^\d{6}$/.test(this.code)) {
                this.codeState = true;
            } else {
                this.codeState = false;
            }
        }
    }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dating_navBottom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dating_navBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dating_navBottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_cookie__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			title: '充值齐齐豆',
			baseInfo: {
				nick: __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('nick'),
				uid: __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('uid')
			},
			qiqidou: '',
			showTips: false,
			userImg: __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('photo'),
			index: 0,
			hasQiqiDou: 0
		};
	},

	computed: {
		isHideLogout: function isHideLogout() {
			var channel = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('channelid');
			return channel != 54 && channel != 55 && channel != 10102;
		}
	},
	components: {
		navtop: __WEBPACK_IMPORTED_MODULE_1__dating_navTop___default.a,
		navbottom: __WEBPACK_IMPORTED_MODULE_2__dating_navBottom___default.a
	},
	mounted: function mounted() {
		var _this = this;
		if (!__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('wxopenid') && this.isWeixin()) {
			if (this.querystr("openid")) {
				__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].set('wxopenid', this.querystr("openid"), { domain: "qxiu.com" });
			} else {
				//					location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3d"+ location.protocol.slice(0,-1) +"%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"; 
				location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
			}
		}
		$.ajax({
			type: "get",
			url: "https://api-live.qxiu.com/webProxy/cgi/webQiQiDouQuery?userId=" + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('uid') + '&meck=' + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('mcheck'),
			async: true,
			dataType: "jsonp",
			success: function success(res) {
				if (res.retcode == 0) {
					_this.hasQiqiDou = res.result.qiqidou;
				} else {
					alert(res.result.msg);
				}
			}
		});

		if (_this.querystr("roomid")) {
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].set('roomid', _this.querystr("roomid"), { domain: 'qxiu.com', encode: true });
		} else {
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('roomid', { domain: 'qxiu.com' });
		}
	},

	methods: {
		switchCoun: function switchCoun() {
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('uid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('accessToken', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('openid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('webToken', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('refreshToken', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('mcheck', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('pgv_pvi', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('closedownLoad', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('tempid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('tempmcheck', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('wxopenid', { domain: 'qxiu.com' });
			__WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].remove('bindPhone', { domain: 'qxiu.com' });
			this.$store.commit('getCurview', 'loginmode');
			location.hash = '/';
		},
		selectedAmount: function selectedAmount(amount, index) {
			this.qiqidou = amount;
			this.index = index;
		},
		pay: function pay() {
			var rmb = this.qiqidou * 10;
			if (!rmb) {
				alert("金额不能为空");
			} else if (rmb && !this.showTips) {
				var u = navigator.userAgent,
				    isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
				    //ios终端
				channel = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('channelid');
				if (channel == 55 && isiOS) {
					location.href = "https://itunes.apple.com/us/app/id1369635949?l=zh&ls=1&mt=8";
					return;
				}
				//					if((channel==54)||(channel==55)||(channel==10102)){
				//						this.qqPay(rmb)
				//					}else{
				this.$store.commit('getOrderRmb', rmb);
				location.hash = '/pay' + (this.querystr('roomid') ? '?roomid=' + this.querystr('roomid') : '');
				//					}
			}
		},
		querystr: function querystr(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.href.slice(window.location.href.indexOf('?')).substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		qqPay: function qqPay(rmb) {
			var buyerId = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('uid');
			var openid = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('openid');
			var openkey = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('accessToken');
			var payToken = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('accessToken');
			var goodsQty = rmb;
			var oemId = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('oemid') || 201;
			var channelId = __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('channelid');
			$.ajax({
				url: 'https://order.qxiu.com/v2/midasPay/createOrder',
				data: { buyerId: buyerId, userId: buyerId, goodsQty: goodsQty, openid: openid, openkey: openkey, payToken: payToken, roomId: 0, agentId: 0, oemId: oemId, channelId: channelId, urlencode: true },
				type: 'get',
				dataType: "jsonp",
				jsonp: 'callbackname',
				async: true,
				success: function success(data) {
					if (data.state == 0) {
						//params.params=data.rs.sandbox; 
						//location.href="https://pay.qq.com/h5/index.shtml?pf=qq_m_qq-10000144-android-10000144-1234&m=buy&c=goods&_version=v3&params=pf&dc=qqcard,mcard,hfpay,yb&sandbox="+data.content.sandbox+"&params="+data.content.params;
						var url = "https://pay.qq.com/h5/index.shtml?openid=" + openid + "&openkey=" + openkey + "&sessionid=openid&sessiontype=kp_actoken&pf=qq_m_qq-10000144-android-10000144-1234&m=buy&c=goods&_version=v3&params=pf&dc=qqcard,mcard,hfpay,yb&params=" + data.content.params;
						if (data.content.sandbox == 1) {
							//沙箱环境
							url = url + "&sandbox=" + data.content.sandbox;
						}
						location.href = url;
					} else {
						alert(data.msg);
					}
				}
			});
		},
		isWeixin: function isWeixin() {
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		}
	},
	watch: {
		qiqidou: function qiqidou() {
			var reg = /\D/g;
			if (reg.test(this.qiqidou)) {
				this.qiqidou = 0;
			}
		}
	},
	directives: {
		toNumber: {
			bind: function bind(el) {
				var reg = /^[1-9]([0-9]{0,3})$/g;
				el.addEventListener('keyup', function () {
					var toggle = reg.test(el.value);
					reg.test(el.value);
					if (!toggle && el.value) {
						el.value = el.value.slice(0, 4);
						alert("请输入1-9999之间的数字");
					}
				}, false);
			}
		}
	},
	filters: {
		limitBy: function limitBy(value) {
			if (value > 99990) {
				return Math.floor(value / 100) * 10;
			} else {
				return value;
			}
		}
	}
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			phone: '', //手机号
			yzImg: '', //图形码
			code: '', //验证码
			userpw: parseInt(Math.random() * 100000000), //密码
			phoneState: false, //手机校验
			yzImgState: false, //图形码校验
			codeState: false, //验证码校验
			tips: '',
			popTips: false,
			yzImgSrc: "https://login-m.qxiu.com/verify/codeImage?size=200x70",
			timer: true,
			timerstr: "获取验证码"
		};
	},

	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['channelID', 'sourceType', 'forceLogin']),
	methods: {
		outPop: function outPop() {
			if (this.forceLogin) {
				this.$store.commit('getCurview', 'loginmode');
				return;
			}
			this.$store.commit('getCurview', '');
		},
		getCode: function getCode() {
			var _this = this;
			if (!(_this.phoneState && _this.yzImgState & _this.timer)) {
				return;
			}
			_this.yzImgSrc = _this.yzImgSrc + '&v=' + Math.random();
			$.ajax({
				type: "get",
				url: "https://login-m.qxiu.com/cgi/web/login/phone/sendCode?phone=" + _this.phone + "&code=" + _this.yzImg.toUpperCase(),
				async: true,
				dataType: "jsonp",
				success: function success(res) {
					if (res.state == 0 && res.content.sendState == true) {
						var time = 60;
						_this.timer = false;
						var interval = setInterval(function () {
							_this.timerstr = time;
							time--;
							if (time == 0) {
								clearInterval(interval);
								_this.timer = true;
								_this.timerstr = "获取验证码";
							}
						}, 1000);
						window.toast("验证码发送成功");
					} else if (res.state != 0) {
						window.toast(res.message);
					}
				}
			});
		},
		regist: function regist() {
			if (this.phoneState && this.codeState) {
				var _this = this;
				$.ajax({
					type: "get",
					url: "https://login-m.qxiu.com/cgi/web/login/phoneReg?phone=" + _this.phone + "&code=" + _this.code + "&password=" + _this.userpw + "&oemid=" + (__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get('oemid') || 201) + "" + (_this.sourceType ? "&sourceType=" + _this.sourceType : '') + (_this.channelID ? "&channelid=" + _this.channelID : ''),
					async: true,
					dataType: "jsonp",
					success: function success(res) {
						if (res.state == 0) {
							$.ajax({
								type: "get",
								url: "https://login-m.qxiu.com/cgi/web/login/phone?phone=" + _this.phone + "&password=" + _this.userpw + "&oemid=" + (__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].get('oemid') || 201) + "" + (_this.sourceType ? "&sourceType=" + _this.sourceType : '') + (_this.channelID ? "&channelid=" + _this.channelID : ''),
								async: true,
								dataType: "jsonp",
								success: function success(res) {
									if (res.state == 0 && res.content.openid) {
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('ip', res.content.ip, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('isNew', res.content.isnew, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('isnp', res.content.isnp, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('mcheck', res.content.meck, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('nick', res.content.nickname, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('openid', res.content.openid, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('accessToken', res.content.openkey, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('uid', res.content.userid, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('webToken', res.content.webToken, { domain: 'qxiu.com' });
										__WEBPACK_IMPORTED_MODULE_0__libs_cookie__["a" /* default */].set('photo', res.content.photo, { domain: 'qxiu.com' });
										_this.$store.commit('getCurview', '');
										location.reload();
									} else {
										window.toast(res.message);
									}
								}
							});
						} else if (res.state == '200501') {
							window.toast('手机号已注册');
						} else {
							window.toast(res.message);
						}
					}
				});
			}
		},
		checkPhone: function checkPhone() {
			if (!/^1[234578]\d{9}$/.test(this.phone)) {
				alert("请输入11位正确的手机号");
			}
		},
		checkPhoneImg: function checkPhoneImg() {
			if (!/^1[234578]\d{9}$/.test(this.phone)) {
				alert("请输入11位正确的手机号");
			} else if (!/^[\d a-z A-Z]{4}$/.test(this.yzImg)) {
				alert("请输入正确的图形验证码");
			}
		}
	},
	watch: {
		phone: function phone() {
			if (/^1[234578]\d{9}$/.test(this.phone)) {
				this.phoneState = true;
			} else {
				this.phoneState = false;
			}
		},
		yzImg: function yzImg() {
			if (/^[\d a-z A-Z]{4}$/.test(this.yzImg)) {
				this.yzImgState = true;
			} else {
				this.yzImgState = false;
			}
		},
		code: function code() {
			if (/^\d{6}$/.test(this.code)) {
				this.codeState = true;
			} else {
				this.codeState = false;
			}
		}
	}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dating_navTop__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dating_navTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dating_navTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dating_navBottom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dating_navBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dating_navBottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_passport__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'index',
	data: function data() {
		return {
			roomInfo: '',
			roomId: ''
		};
	},

	components: {
		navtop: __WEBPACK_IMPORTED_MODULE_0__dating_navTop___default.a,
		navbottom: __WEBPACK_IMPORTED_MODULE_1__dating_navBottom___default.a
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['searchRoomId']),
	mounted: function mounted() {
		this.roomId = this.searchRoomId || __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('searchRoomId');
		if (/^[2]\d{5}$/ig.test(this.roomId)) {
			this.checkRoomId();
		} else if (/^[34]\d{5}$/ig.test(this.roomId)) {
			this.checkAnchorId();
		}
	},

	methods: {
		checkLogin: function checkLogin(roomId) {
			if (__WEBPACK_IMPORTED_MODULE_2__libs_passport__["a" /* default */].isLogin()) {
				location.href = location.protocol + "//h5.qxiu.com/room.html?roomid=" + roomId + "&channelid=" + __WEBPACK_IMPORTED_MODULE_3__libs_cookie__["a" /* default */].get('channelid');
			} else {
				this.$store.commit('getCurview', 'loginmode');
				location.hash = '/';
			}
		},
		checkRoomId: function checkRoomId() {
			if (this.roomId) {
				var _this = this;
				$.ajax({
					type: "get",
					url: "https://api.qxiu.com/op-api/room_pic_info?id=" + this.roomId,
					async: true,
					dataType: "jsonp",
					success: function success(res) {
						if (res.result && res.result.data.result == 0) {
							_this.roomInfo = res.result.data;
						} else {
							alert("该房间不存在");
							location.hash = "/";
						}
					}
				});
			}
		},
		checkAnchorId: function checkAnchorId() {
			if (this.roomId) {
				var _this = this;
				$.ajax({
					type: "get",
					url: "https://datacenter.qxiu.com/cgi/anchor/micInfo?anchorIds=[" + _this.roomId + "]",
					async: true,
					dataType: "jsonp",
					success: function success(res) {
						if (res.result && res.result.mics && res.result.mics[_this.roomId]) {
							var roomid = res.result.mics[_this.roomId].roomId + '';
							if (/^[1]{6}/gi.test(roomid)) {
								roomid = roomid.slice(1);
							}
							_this.roomInfo = {
								roomId: roomid,
								roomName: roomid,
								roomPic: 'https://static.qxiu.com/h5/img/static/default2.png'
							};
						} else {
							_this.roomInfo = {
								roomId: '1' + _this.roomId,
								roomid: _this.roomId,
								roomName: _this.roomId,
								roomPic: 'https://static.qxiu.com/h5/img/static/default2.png'
							};
						}
					}
				});
			}
		}
	}
});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

(function () {
	var b = {};
	var a = {};
	a.PADCHAR = "=";
	a.ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	a.makeDOMException = function () {
		var f, d;
		try {
			return new DOMException(DOMException.INVALID_CHARACTER_ERR);
		} catch (d) {
			var c = new Error("DOM Exception 5");
			c.code = c.number = 5;
			c.name = c.description = "INVALID_CHARACTER_ERR";
			c.toString = function () {
				return "Error: " + c.name + ": " + c.message;
			};
			return c;
		}
	};
	a.getbyte64 = function (e, d) {
		var c = a.ALPHA.indexOf(e.charAt(d));
		if (c === -1) {
			throw a.makeDOMException();
		}
		return c;
	};
	a.decode = function (f) {
		f = "" + f;
		var j = a.getbyte64;
		var h, e, g;
		var d = f.length;
		if (d === 0) {
			return f;
		}
		if (d % 4 !== 0) {
			throw a.makeDOMException();
		}
		h = 0;
		if (f.charAt(d - 1) === a.PADCHAR) {
			h = 1;
			if (f.charAt(d - 2) === a.PADCHAR) {
				h = 2;
			}
			d -= 4;
		}
		var c = [];
		for (e = 0; e < d; e += 4) {
			g = j(f, e) << 18 | j(f, e + 1) << 12 | j(f, e + 2) << 6 | j(f, e + 3);
			c.push(String.fromCharCode(g >> 16, g >> 8 & 255, g & 255));
		}
		switch (h) {
			case 1:
				g = j(f, e) << 18 | j(f, e + 1) << 12 | j(f, e + 2) << 6;
				c.push(String.fromCharCode(g >> 16, g >> 8 & 255));
				break;
			case 2:
				g = j(f, e) << 18 | j(f, e + 1) << 12;
				c.push(String.fromCharCode(g >> 16));
				break;
		}
		return c.join("");
	};
	a.getbyte = function (e, d) {
		var c = e.charCodeAt(d);
		if (c > 255) {
			throw a.makeDOMException();
		}
		return c;
	};
	a.encode = function (f) {
		if (arguments.length !== 1) {
			throw new SyntaxError("Not enough arguments");
		}
		var g = a.PADCHAR;
		var h = a.ALPHA;
		var k = a.getbyte;
		var e, j;
		var c = [];
		f = "" + f;
		var d = f.length - f.length % 3;
		if (f.length === 0) {
			return f;
		}
		for (e = 0; e < d; e += 3) {
			j = k(f, e) << 16 | k(f, e + 1) << 8 | k(f, e + 2);
			c.push(h.charAt(j >> 18));
			c.push(h.charAt(j >> 12 & 63));
			c.push(h.charAt(j >> 6 & 63));
			c.push(h.charAt(j & 63));
		}
		switch (f.length - d) {
			case 1:
				j = k(f, e) << 16;
				c.push(h.charAt(j >> 18) + h.charAt(j >> 12 & 63) + g + g);
				break;
			case 2:
				j = k(f, e) << 16 | k(f, e + 1) << 8;
				c.push(h.charAt(j >> 18) + h.charAt(j >> 12 & 63) + h.charAt(j >> 6 & 63) + g);
				break;
		}
		return c.join("");
	};
	b.pay = function (d) {
		var c = encodeURIComponent(a.encode(d));
		location.href = "https://static.qxiu.com/h5/static/pay.htm?goto=" + c;
		//		location.href = "static/pay.htm?goto=" + c
		//		location.href = "#/pay?goto=" + c
		//		location.href = "http://h5.qxiu.com/#/pay?goto=" + c
	};
	b.decode = function (c) {
		return a.decode(decodeURIComponent(c));
	};
	window._AP = b;
})();

/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * Created by Sunny on 2016/4/5.
 */
//levelObj:贵族等级，privilege特权
module.exports = {
    levelObj: [{
        level: 0,
        name: '平民',
        totalScore: 50,
        get_score: 0,
        safeScore: 0,
        minusScors: 0,
        privilege: [],
        num: {
            flower: 3,
            color: '天蓝色'
        }
    }, {
        level: 1,
        name: '富民',
        totalScore: 50,
        get_score: 50,
        safeScore: 10,
        minusScors: 30,
        privilege: [9, 10, 16, 7, 11],
        num: {
            flower: 3,
            color: '天蓝色'
        }
    }, {
        level: 2,
        name: '财主',
        totalScore: 100,
        get_score: 100,
        safeScore: 10,
        minusScors: 30,
        privilege: [9, 10, 16, 7, 11],
        num: {
            flower: 3,
            color: '天蓝色'
        }
    }, {
        level: 3,
        name: '富贾',
        totalScore: 100,
        get_score: 200,
        safeScore: 10,
        minusScors: 60,
        privilege: [9, 10, 16, 7, 11],
        num: {
            flower: 3,
            color: '天蓝色'
        }
    }, {
        level: 4,
        name: '富商',
        totalScore: 200,
        get_score: 300,
        safeScore: 10,
        minusScors: 60,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 6,
            color: '天蓝色',
            expression: 3
        }
    }, {
        level: 5,
        name: '富翁',
        totalScore: 500,
        get_score: 500,
        safeScore: 50,
        minusScors: 120,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 6,
            color: '天蓝色',
            expression: 3
        }
    }, {
        level: 6,
        name: '巨富',
        totalScore: 1000,
        get_score: 1000,
        safeScore: 100,
        minusScors: 300,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 6,
            color: '天蓝色',
            expression: 3
        }
    }, {
        level: 7,
        name: '富豪',
        totalScore: 1000,
        get_score: 2000,
        safeScore: 150,
        minusScors: 600,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 9,
            color: '天蓝色',
            expression: 3
        }
    }, {
        level: 8,
        name: '勋爵',
        totalScore: 1000,
        get_score: 3000,
        safeScore: 200,
        minusScors: 600,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 9,
            color: '红色',
            expression: 3
        }
    }, {
        level: 9,
        name: '男爵',
        totalScore: 1000,
        get_score: 4000,
        safeScore: 300,
        minusScors: 600,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 9,
            color: '红色',
            expression: 3
        }
    }, {
        level: 10,
        name: '子爵',
        totalScore: 5000,
        get_score: 5000,
        safeScore: 500,
        minusScors: 600,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 9,
            color: '红色',
            expression: 5
        }
    }, {
        level: 11,
        name: '伯爵',
        totalScore: 10000,
        get_score: 10000,
        safeScore: 1000,
        minusScors: 3000,
        privilege: [8, 9, 10, 16, 7, 11],
        num: {
            flower: 12,
            color: '红色',
            expression: 5
        }
    }, {
        level: 12,
        name: '侯爵',
        totalScore: 10000,
        get_score: 20000,
        safeScore: 2000,
        minusScors: 6000,
        privilege: [6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 12,
            color: '红色',
            expression: 5
        }
    }, {
        level: 13,
        name: '公爵',
        totalScore: 10000,
        get_score: 30000,
        safeScore: 3000,
        minusScors: 6000,
        privilege: [6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 12,
            color: '红色',
            expression: 5
        }
    }, {
        level: 14,
        name: '王爵',
        totalScore: 20000,
        get_score: 40000,
        safeScore: 4000,
        minusScors: 6000,
        privilege: [4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 15,
            color: '红色',
            expression: 5
        }
    }, {
        level: 15,
        name: '郡王',
        totalScore: 20000,
        get_score: 60000,
        safeScore: 6000,
        minusScors: 12000,
        privilege: [4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 15,
            color: '玫红色',
            expression: 5
        }
    }, {
        level: 16,
        name: '藩王',
        totalScore: 20000,
        get_score: 80000,
        safeScore: 8000,
        minusScors: 12000,
        privilege: [4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 15,
            color: '玫红色',
            expression: 8
        }
    }, {
        level: 17,
        name: '亲王',
        totalScore: 50000,
        get_score: 100000,
        safeScore: 10000,
        minusScors: 12000,
        privilege: [4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 20,
            color: '玫红色',
            expression: 8
        }
    }, {
        level: 18,
        name: '国王',
        totalScore: 50000,
        get_score: 150000,
        safeScore: 15000,
        minusScors: 30000,
        privilege: [4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 20,
            color: '玫红色',
            expression: 8,
            blackcard: '荣耀'
        }
    }, {
        level: 19,
        name: '皇帝',
        totalScore: 100000,
        get_score: 200000,
        safeScore: 20000,
        minusScors: 30000,
        privilege: [5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 20,
            color: '玫红色',
            expression: 8,
            blackcard: '荣耀'
        }
    }, {
        level: 20,
        name: '大帝',
        totalScore: 200000,
        get_score: 300000,
        safeScore: 20000,
        minusScors: 40000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 25,
            color: '玫红色',
            expression: 8,
            blackcard: '荣耀'
        }
    }, {
        level: 21,
        name: '帝王',
        totalScore: 200000,
        get_score: 500000,
        safeScore: 20000,
        minusScors: 40000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 25,
            color: '玫红色',
            expression: 8,
            blackcard: '荣耀'
        }
    }, {
        level: 22,
        name: '帝尊',
        totalScore: 300000,
        get_score: 700000,
        safeScore: 25000,
        minusScors: 40000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 25,
            color: '紫色',
            expression: 8,
            blackcard: '至尊'
        }
    }, {
        level: 23,
        name: '圣尊',
        totalScore: 500000,
        get_score: 1000000,
        safeScore: 25000,
        minusScors: 50000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 30,
            color: '紫色',
            expression: 12,
            blackcard: '至尊'
        }
    }, {
        level: 24,
        name: '上神',
        totalScore: 500000,
        get_score: 1500000,
        safeScore: 25000,
        minusScors: 50000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 30,
            color: '紫色',
            expression: 12,
            blackcard: '至尊'
        }
    }, {
        level: 25,
        name: '天神',
        totalScore: 1000000,
        get_score: 2000000,
        safeScore: 30000,
        minusScors: 50000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 30,
            color: '紫色',
            expression: 12,
            blackcard: '至尊'
        }
    }, {
        level: 26,
        name: '神皇',
        totalScore: 1000000,
        get_score: 3000000,
        safeScore: 40000,
        minusScors: 100000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 35,
            color: '紫色',
            expression: 12,
            blackcard: '至尊'
        }
    }, {
        level: 27,
        name: '神尊',
        totalScore: 1000000,
        get_score: 4000000,
        safeScore: 50000,
        minusScors: 100000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 35,
            color: '紫色',
            expression: 12,
            blackcard: '至尊'
        }
    }, {
        level: 28,
        name: '天尊',
        totalScore: 1500000,
        get_score: 5000000,
        safeScore: 100000,
        minusScors: 100000,
        privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
        num: {
            flower: 35,
            color: '紫色',
            expression: 12,
            blackcard: '至尊'
        }
    }],
    privilege: {
        //1: {
        //    title: '踢人',
        //    info: '大长腿想踢谁就踢谁'
        //},
        2: {
            title: '防踢',
            info: '铁屁股你就是踢不动'
        },
        //3: {
        //    title: '禁言',
        //    info: '让你话多shut up  '
        //},
        4: {
            title: '防禁言',
            info: '想说啥就说啥'
        },
        5: {
            title: '贵族隐身',
            info: '就是喜欢逗主播玩'
        },
        6: {
            title: '贵族标识隐身',
            info: '咱是有身份的人'
        },
        7: {
            title: '聊天文字颜色',
            info: '说话都那么贵气'
        },
        8: {
            title: '专属表情',
            info: '不一样的表达'
        },
        9: {
            title: '专属贵族标识',
            info: '咱是有身份的人'
        },
        10: {
            title: '排名靠前',
            info: '就是高高在上'
        },
        11: {
            title: '鲜花数量',
            info: '花的海洋'
        },
        //12: {
        //    title: '自动回复',
        //    info: '就是这么智能'
        //},
        //13: {
        //    title: '随意进入满员房间',
        //    info: '咱有有专属VIP通道'
        //},
        //14: {
        //    title: '屏蔽房间广告',
        //    info: '世界一下就清净了'
        //},
        //15: {
        //    title: '黑卡会员资格',
        //    info: 'VIP中的VIP '
        //},
        16: {
            title: '进房间欢迎特效',
            info: '进房间欢迎特效'
        }
    }
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie__ = __webpack_require__(0);
/**
 * Created by 11789 on 2017/7/10.
 * @discription
 * @parameter
 * @example
 */


/* harmony default export */ __webpack_exports__["a"] = ({
    uuid: function uuid() {
        return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    PV: function PV() {
        var that = this;
        var uuid = null;
        if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uuid")) {
            uuid = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uuid");
        } else {
            uuid = that.uuid();
            __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].set("uuid", uuid, { domain: "qxiu.com" });
        }

        this.timeFormat();
        var host = "https://point-report.qxiu.com/cgi/dataReport/business/common";
        var param = {};
        param._biz = "pvRecord";
        param.operTime = new Date().format("yyyy-MM-dd hh:mm:ss");
        param.oemId = 201;
        __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("channelid") && (param.channelId = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("channelid"));
        param.version = "1.0.0";
        param.modelId = "5";
        param.place = "284";
        param.appId = 101;
        param.pcId = uuid;

        if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("loginType")) {
            switch (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("loginType")) {
                case "qq":
                    param.loginType = 1;
                    break;
                case "wechatGZH":
                    param.loginType = 2;
                    break;
                case "weibo":
                    param.loginType = 3;
                    break;
                case "phone":
                    param.loginType = 4;
                    break;
            }
        }
        if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uid")) {
            param.userId = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uid");
        } else if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("tempid")) {
            param.userId = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("tempid");
        } else {
            this.getTempid();
            return;
        }

        var oImg = new Image();
        oImg.src = host + "?" + $.param(param);
    },
    getTempid: function getTempid() {
        var that = this;
        that.uid = Math.floor(Math.random() * 1000000000) + 90000000000; // 9xx xxxx xxxx  以9打头 11位的游客ID;
        $.ajax({
            type: "post",
            url: "https://api-live.qxiu.com/webProxy/cgi/getMCheck",
            async: true,
            data: {
                userId: that.uid
            },
            dataType: "jsonp",
            success: function success(data) {
                if (data.result.mcheck) {
                    that.mcheck = data.result.mcheck;
                    __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].set("tempid", that.uid, {
                        encode: false,
                        domain: "qxiu.com"
                    });
                    __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].set("tempmcheck", that.mcheck, {
                        encode: false,
                        domain: "qxiu.com"
                    });
                    setTimeout(function () {
                        that.PV();
                    }, 3 * 1000);
                } else {
                    setTimeout(function () {
                        that.getTempid();
                    }, 3 * 1000);
                }
            }
        });
    },
    timeFormat: function timeFormat() {
        Date.prototype.format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小时
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                S: this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
                }
            }
            return fmt;
        };
    },
    dataReport: function dataReport() {
        var that = this;
        var uuid = null;
        if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uuid")) {
            uuid = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uuid");
        } else {
            uuid = that.uuid();
            __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].set("uuid", uuid, { domain: "qxiu.com", expire: 24 * 365 });
        }

        var host = "https://point-report.qxiu.com/cgi/dataReport/business/common";
        var param = {};
        param._biz = "pvRecord";
        param.operTime = new Date().format("yyyy-MM-dd hh:mm:ss");
        param.oemId = 201;
        param.channelId = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("channelid");
        param.version = 1.0;
        param.pcId = uuid;
        param.appId = 101; //齐齐

        if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("loginType")) {
            switch (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("loginType")) {
                case "qq":
                    param.loginType = 1;
                    break;
                case "wechatGZH":
                    param.loginType = 2;
                    break;
                case "weibo":
                    param.loginType = 3;
                    break;
                case "phone":
                    param.loginType = 4;
                    break;
            }
        }
        if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uid")) {
            param.userId = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("uid");
        } else if (__WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("tempid")) {
            param.userId = __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */].get("tempid");
        }

        $(".dataReport").click(function (e) {
            param.modelId = 5;
            param.place = $(this).attr("data-place");
            var oImg = new Image();
            var url = host + "?" + $.param(param);
            oImg.src = url;
        });
    }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rem__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_cookie__ = __webpack_require__(0);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_3__rem__["a" /* default */].init(window);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.HTMLEscape = function (sHtml) {
	if (sHtml == null) {
		return '';
	}
	return sHtml.replace(/[<>&"]/g, function (c) {
		return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
	});
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('title', {
	inserted: function inserted(el, bind) {
		document.title = bind.value;
	}
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
	inserted: function inserted(el, bind) {
		if (bind.value) {
			el.focus();
		}
	}
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

window.toast = function (txt, callback) {
	$('body').append('<div class="toast">' + txt + '</div>');
	setTimeout(function () {
		$('.toast').remove();
		if (callback) {
			callback();
		}
	}, 2000);
};
window.querystr = function (name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
};

//var xiaoxiongChannel = [731100001,731100002,731300001]
//var channelid = querystr('channelid')||cookie.get('channelid')||0;
//if(xiaoxiongChannel.indexOf(channelid-0) != -1){
//	cookie.set('isxiaoxiong', true, {
//		domain: 'qxiu.com',
//		encode: true
//	})
//	console.log(1111)
//	cookie.set('oemid',43, {domain: 'qxiu.com',encode: true})
//	sessionStorage.setItem('isxiaoxiong',true)
//}else{
//	cookie.set('isxiaoxiong', false, {
//		domain: 'qxiu.com',
//		encode: true
//	})
//	sessionStorage.setItem('isxiaoxiong',false)
//}

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAjCAYAAAD8BaggAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUFCMDYyOEQxMjcwMTFFQUE5MTBFQTYzQkNENUVFNDYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUFCMDYyOEMxMjcwMTFFQUE5MTBFQTYzQkNENUVFNDYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N2Y3N2Y4OTAtOWU4MS00Zjc3LTk3NjQtNzA4ZDVlNGQzNDJiIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+siM5BwAAAYBJREFUeNpi/P//P8NgAowoDrrA6AskC4HYFIh56GD/FyA+DcR9DAb/t6A66AJjC5CsHsDAaQU6qgbioAuMPkCBzUD8C4hLgXgJUPIdTq0XGCmz2gAeCIJAMhaIu4GYDYj9YA7aB+Q4AnEBUPFEggZSy0EI88qBZAcQ74c56BOQwwvEwnhDhnYOEgKSb4H4M8xB/6EKibOJ2g6CmAkWZGIYZGDQOQg1ykYdRMhBo4l6CCRqlkHjEmhyGZFRlgHEogQyCS8QbwViC1pHWQ4QT4bSoMr7NVbHMDBsB2JreoTQKiC+CsTaoJocI6QgjtkGdcxRII6gtYNeQUMG01EIx9hAHeMJTNif6ZGGXmM46gIjyFHL0R1D75JaFBpC2khiW4E4EuYYejnoPznZ/jNSy21QlNRnoPEManBPpLIdjDhDDUuMwEKoH0p3AUMpD9obGOCOIvX6ZYyUpCH0nqsfuCvEwGAGxNwD7yBiAaUNNCLS0GgDbdRB1BkfGnUQJgAIMADee6cyzO6RlwAAAABJRU5ErkJggg=="

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUFDNUJDRTMxMjcwMTFFQUE5MTBFQTYzQkNENUVFNDYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUFDNUJDRTIxMjcwMTFFQUE5MTBFQTYzQkNENUVFNDYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N2Y3N2Y4OTAtOWU4MS00Zjc3LTk3NjQtNzA4ZDVlNGQzNDJiIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+j/RWygAAA75JREFUeNrEWF1sDFEUnh3aoH8iJEholLII6oFaRaIVReONtfHc8GCrgkSloV3SiEYTFIl68KRs+9isbJPyUm0jIkoaJVQjPAgvqvXTFus78k1da2dN92d6kq9n78y593w9986Zc8YRCoU0K3J28IHxcwFQDGwAlgLZQAbvDQKvgV7gHtAK9MuNYxlrLPlxWCEEMpOg3IAXcMk8zZrI4l3AJaAJpH7ETQhktkDVA05eGgJuA3eBbkZggPeyGME8YDNQAqTz3jOgDKTaYiIEIlOgLgD7eOmVXAYaScqKCBkPcBzI4bUGoBzEvlkmBDKzoAKAbLxMrALOAyNabJIKHAJ8gPyjciBLQOpDuKFuQqadZCQqLkysjYOMyAjXcHFNWbudvswJwWAaVAuwBOgBCrBQt5Yg4VoFXFt8tNCnaYTkzOQDL4EiLPBOS7BwzUL6yKfPfwnxaSrlmXFj4nstScKzs5u+Sun7DyFcEH2R13yY8EhLsnD7fBzWM9eNRWgPs24fUKfZJ3X06WTiHSN0wNg5MB+1iw191XLo/U0IoZLMup7JrlGzX27QtwtcciRC2/huCoDxZ7vZ0GeAHIp15gWN7yY1J7mBHmBYtLHHYeJmThmmNrUx1pF1I9gYvguE0HIOHitkdkH5eS+V2h/mMGabCKSeUC8TQvM46FMMqqkrWetUcnwyCTYak6RItq4UV58Ug1zqc9jjISVH5Uay4aGMahNlHdV3um5y1l5QH0V4pYQ4GHb9LxuWGVFtoqwj8tNI1DrLTpFMxcDIoDW8X8Px6STYiEynHhBCbzhYqDyKzSyspDYepfbwgBoSsw3W94cRmk/9djL+PGXJuRK4r5Dyq4srRb4q/jACpjb/KfJXU/fq7A5EirSJk0LqDp2titSxOxCFNLuZwOdUNgMiAR2hlJKyk4//3gmIjofdSie49BuP/WXj6IBxio3RkTNcweEVtfxoYt8kT9phG6Mjnchi4Dlwa4wQO8oyGlWBeZ4N0VkBdYrDcqOr1ZXHXDrK64AcsuZILUoCyWQxR4mvBvhuNes6vMxFi4A7mDg7SZyk9pnB322mbRCYfoHayT2VkHYkY/vg56P6WoGPVNPOlS3KJuAh+/EuTKhgPZNIucq3RK5RT0ckRFLSk23khwHpxc/wPSR9W1qCovQd6giHJ/BPzzQlxAlfgf34uZVbKNG6BkjneZNfRdYCcvhTlM8xc/lfz7FAKggV5Nu+OpYPVpIa1o3jg9V4RCK2yhHjJ73t/KTnZOmQqUQpHgn+EmAAhR5mWQG3dZMAAAAASUVORK5CYII="

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUFCQzk2NDYxMjcwMTFFQUE5MTBFQTYzQkNENUVFNDYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUFCQzk2NDUxMjcwMTFFQUE5MTBFQTYzQkNENUVFNDYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N2Y3N2Y4OTAtOWU4MS00Zjc3LTk3NjQtNzA4ZDVlNGQzNDJiIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+zF6SswAAAopJREFUeNrsmMlrFEEUh9NN4sGAJhMEFQ8KXgKReJKgBFSCaBAXMBdRI+hVXE5qogfHkOBBL/4B6oiHRHAlLoiMhhhRwQWPgjmIBkSNWw5RHL8Hv4amSXranplMI1Pw8YqaelW/et1V87qcXC5XlaRS7VUubv/ag7m849Lc5/mc6BtsmgXXVN8Ev8L8mSM43jzMeUi7arAwHYXH1A+D+w+Lmg1XYL24qrZIhbnWYF7BBngUnLgGeiFLx8URxquDu9AO30S72uryCKmGE1TvwXyvPSjIVvgeWuElDp0hY9ogWVgFH2T99ax/ooCYRZj7cAwcODOlIJ6trWyZvUswB87hPAANgTEtekPQDG8k4LVYqbZm9VkS8N0IL7ToT/bOMe+h6SJkoj5DB9VOPYJt9owRtU6ra7JnDUstihr4rW+IUS/C6jMMTXrxT8N1aJDY5cx10z+/G7ITLvhWuRBuI6Yf+xAWaKLVMDaF+5h+G1bfIUXlINgGSsNa5ngXdHTzbM9RDXxEW9kiVw+DYBEbD3EfV59BveCNEtrGuMfhd+g5FCLqD6aP6NzB7tci9uQ7a1QmYKvOKDt8NsPHSAdjBGF2YO6e5mAMK5M6YyIVtyphpSKoIigpguwUviVqyi2ooPSj2IJipx+lEBQ7/SiFoELSj+IKKiD9KL4gxLRgHsRIP8ynpRQROgupGOlHSr5FF7QPMrBFqUXU9CMj3+jfZRFTkBHMSIz0Y1flv+y/F/Rd2zpVDhG+eX94gp7J7ixTYPbKPvV2mX3K2kf/KV08ZNhRX2YgMvUKQtrT4Xj3Q/x4EtNVxtenhyB0O/4LK0TZ3c4BWAG1MyDiJzyxyCDmhjU4SbtBS9y2/yvAAHqQ5ObGYfCxAAAAAElFTkSuQmCC"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkIyMjZGOUIxMjZGMTFFQUI0QzRCOTdGMDYzOUIyNDEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkIyMjZGOUExMjZGMTFFQUI0QzRCOTdGMDYzOUIyNDEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3Zjc3Zjg5MC05ZTgxLTRmNzctOTc2NC03MDhkNWU0ZDM0MmIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N2Y3N2Y4OTAtOWU4MS00Zjc3LTk3NjQtNzA4ZDVlNGQzNDJiIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+baG6bAAAAcRJREFUeNrsmD1Lw1AUhhsp7dLaTi5KBxcXgx+DOipIHXTSSTcXdeyqP8DfoL+gk046iIJzRYTaLrWgUMzmoNUO7RLfC28gsQna5uSSwQsPJ5Ryz9Obew731rBtOxGnMZKI2Ug6D7VazXlMgQOwDaZBRjjnF6iDMjgBPfWhaZpeIY5xcAFmI1wE9QOXyC7YAJbfK0u5ZJpgC+SAIUyOczeZ6xKk/YT2+YUnsADOQTuCFWpzbpWjAWbAnp/QDuMheNewf1WOox+5PULzjDcai+qacS5oDyUiek1B45MxHds+FN/GyJIcdhQYW3FYoQlwSwpxEFIb8w1MSkhJCH2AIriTkJLa1GJSklXmSFXCSEmXvZJaCyPlLnvpo6OSWqTUyl9bgo7GaAy7QoaQgDrvXHF1XsDyIA1TeoVCyUgLhZaRFBKRkRISk5ESyoIx8BxWJqgPDVptrxQROX4khfZQS6oy3K+sxziq8YCYcd1m+4QeGFc1ChUZ635CZcZjkNcgk2cud26P0CmogimeazZZQdIjy7krzPXI3H2bugvWXff7Mw2rVGXOblAfstjgSuAedCKQ6HDuEu/3ludo8P8P2i/jW4ABALuzZcl0ZUm+AAAAAElFTkSuQmCC"

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAlCAYAAACzpJKIAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NEMwMkE5NzMwQTkxMTFFQTk5NzJBMjc4MzgzQjU2NkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NEMwMkE5NzQwQTkxMTFFQTk5NzJBMjc4MzgzQjU2NkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0QzAyQTk3MTBBOTExMUVBOTk3MkEyNzgzODNCNTY2QSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0QzAyQTk3MjBBOTExMUVBOTk3MkEyNzgzODNCNTY2QSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Plp4cL4AAAFnSURBVHja7Je9S0JRGMaPl6gGFffALVqEPoaMZmupyS0Xg6CPrTH7A6L/wByEnNyamkoawyKiwqm2wF1SMZx6HnhcbsvNe49DnBd+vp6Dvr97uGd439jg8tAopgEXOyAD4mb86IEWqIOL2WJ5yM2YZHPgGiyZ6OMFbEPYpownepDoA5yABvgKUglFfu19146SSDlwDubBK8hO4eNAondugE7Yo+AB+KBXkN4hN8Ei2PfwUdBvSlGIfFLWO9WyQNmKFg1jJ26Vlz3dQhP0HY1xuq6+znhmguFkTuZkTuZkTuZk/0mWBjegq5y2KauCDbXmzDWbsjXfet2mrOlb39uU7amZ7Svv/uXP7PWHalSTARrVT72rwIF+fzR69XiyZy1ylm78pnLL08DGOAOpKC04VUp1GXXKKpqfFsAjyINESEkC5DX3se4bPZOYPHmQLU6eo9vY1iB4DJ5028JEX3VYb5Uibv4IMACnYVlxf1NNeAAAAABJRU5ErkJggg=="

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmZDI1YTM0NC1kNmVjLTQzYjQtOWNmNS1mMTE3Y2ZiYjQ4OWIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0FCOUYxODYxMUE5MTFFQUEwNkRFNjEyQjBCOTkzQzciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0FCOUYxODUxMUE5MTFFQUEwNkRFNjEyQjBCOTkzQzciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZDI1YTM0NC1kNmVjLTQzYjQtOWNmNS1mMTE3Y2ZiYjQ4OWIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6ZmQyNWEzNDQtZDZlYy00M2I0LTljZjUtZjExN2NmYmI0ODliIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+MyhxVgAAApZJREFUeNrMmEtLHEEQx2eN0WMkB+PjIBiRgHtL1ChZXQIJ+LwEgqIJCkG/QRLwcZBAvkgOycEQjRJERdcHeFEUVtCbntUQs24MPjL5N/RAW9TMzsz2zG7B79Blb/Xf7trtqo6Ypml4sHugE8RAFFSBEiCC/AKHYBckwAw4MvyaEOaCOJgFV6Z7uwRTIOZyjRtkmlALfpjZ2zSo1iVsAKRMfXYKerMRFgEfHBbYBCPyeMtAIbgNyqVvDGzbfPYfGPUr7KNN0AXw2MNxPAFLNrHeexU2yAQ5k37DB2L334A/zM71uBUmEj1NAhyBep+iVJrACYn9G9x3I2yOfFAkfoMGURaNzM7NZBL2nDnCVxpFWQwx68SdhM2TyXMBiLJybpmsNWsnrBJck8kPAxJmfVvpDVFK5xXgVuoGBcottQE2jeBsDewo40LQTicJQS3E99UI3ibJOM4JixLfagjC6BpRTlgV8e2FIGyfjKkGQ3xL1ILMJPkWlBWDv8r4Qvpu7Fg+mMkdZUrdQVmRBm13yTjFCTskvgchCKNrHHDCksQXC0FYGxknOWErxPciBGFdZJzgmpEK5kp6lOsrya7kCfIST5C1vjtVF8+YcuR1PpQ93K6dyeIup4ViGKX1T6adq3bbjAwwW53OshkZBudMM/JSV/u26KN9S+hq36z/csKh4d1SGl7R5BZJxM/OUzAOdhwa3hEdTwRpzU8EtJdsBu+4PM6kvEbTo8oUk+hNyuvRJc05L89Q0x6foS7AN5lrXMy3ZP6VKi7i8eGuFHSAVlAnK8878m+nskpIyvtXPNwdO8RqBOvgluK7Bn3gi1dhuq0HfGLEtea6gv0M+qUYy4TI9nworTlxq7k+StXqZf6K1m7xvwADAIqJIgtgp0GyAAAAAElFTkSuQmCC"

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(121),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4dba7ec9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(116),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-186d47a9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a729226",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56bf302c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b347a78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(117),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34e674c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(126),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f069e22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(115),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-184b0e33",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05b0503f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(118),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f96deb1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b2b6ec0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "recharge"
  }, [_c('navtop', {
    attrs: {
      "index": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "charge-con"
  }, [_c('div', {
    staticClass: "ye"
  }, [_c('p', [_vm._v("剩余齐齐豆")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.hasQiqiDou))])]), _vm._v(" "), _c('div', {
    staticClass: "chargeWrap"
  }, [_c('ul', {
    staticClass: "chargeList"
  }, [_c('li', {
    class: _vm.index == 0 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(1, 0)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qiqidou),
      expression: "qiqidou"
    }, {
      name: "toNumber",
      rawName: "v-toNumber"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "齐齐豆"
    },
    domProps: {
      "value": (_vm.qiqidou)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.qiqidou = $event.target.value
      }
    }
  }), _c('span', [_vm._v("万")]), _c('br'), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm._f("limitBy")(_vm.qiqidou * 10)) + "元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 1 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(1, 1)
      }
    }
  }, [_c('p', [_vm._v("1万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("10元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 2 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(20, 2)
      }
    }
  }, [_c('p', [_vm._v("20万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("200元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 3 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(50, 3)
      }
    }
  }, [_c('p', [_vm._v("50万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("500元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 4 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(300, 4)
      }
    }
  }, [_c('p', [_vm._v("300万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("3000元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 5 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(500, 5)
      }
    }
  }, [_c('p', [_vm._v("500万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("5000元")])])]), _vm._v(" "), _c('div', {
    staticClass: "charge-btn",
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("立即充值")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.showTips) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v("请输入1-9999之间的数字")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTips = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.showTips = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("充值提示:")]), _vm._v(" "), _c('p', [_vm._v("1:请确认您的账号确认无误。")]), _vm._v(" "), _c('p', [_vm._v("2:充值比例为1:1000即1元人民币=1000齐齐豆")]), _vm._v(" "), _c('p', [_vm._v("3:如果有任何问题请联系客服QQ:8007777777")])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [(_vm.showIfr) ? _c('div', {
    staticClass: "slideWrap"
  }, [_c('iframe', {
    attrs: {
      "id": "iframe1",
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "phone"
  }, [_c('span', [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "focus": _vm.checkPhoneImg,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "getcodeBtn",
    attrs: {
      "disabled": !(_vm.phoneState & _vm.timer)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.timerstr))])]), _vm._v(" "), _c('div', {
    staticClass: "btnLogin",
    attrs: {
      "disabled": !(_vm.phoneState && _vm.codeState)
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n            登录\n        ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.outPop
    }
  }), _vm._v(" "), (_vm.popTips) ? _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        (_vm.popTips = false) && (_vm.tips = '')
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        (_vm.popTips = false) && (_vm.tips = '')
      }
    }
  }, [_vm._v("x")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            登录即代表您同意\n            "), _c('a', {
    attrs: {
      "href": "https://client.qxiu.com/statement/privacy4.html"
    }
  }, [_vm._v("齐齐服务和隐私条款")])])
}]}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('关注列表'),
      expression: "'关注列表'"
    }],
    staticClass: "care"
  }, [_c('navtop'), _vm._v(" "), _c('div', {
    staticClass: "wrap",
    style: ('overflow:scroll;-webkit-overflow-scrolling: touch;')
  }, [_c('div', {
    staticClass: "focus"
  }, [_vm._l((_vm.attentList), function(item) {
    return _c('div', {
      class: item.isOnline == 0 ? 'offLine' : 'fff'
    }, [_c('a', {
      attrs: {
        "href": item.isOnline == 1 ? (_vm.protocol + '//h5.qxiu.com/room.html?roomid=' + item.roomId + '&channelid=' + _vm.channelid) : 'javascript:void(0)'
      }
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": 'https://qiqi-resource-v6.qxiu.com' + item.picUrl_L.slice(29) || 'https://static.qxiu.com/h5/static/sDefault.png'
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "roomInfo"
    }, [_c('span', [_vm._v(_vm._s(item.anchorNickName.slice(0, 6)))]), _c('span', [_c('img', {
      staticClass: "viewer",
      attrs: {
        "src": __webpack_require__(13)
      }
    }), _vm._v(_vm._s(item.isOnline == 0 ? 0 : item.roomNum))])]), _vm._v(" "), (item.isOnline != 0) ? _c('span') : _vm._e()])
  }), _vm._v(" "), (_vm.onlingAttentList.length == 0) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v("还没有关注主播哦~")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "recommend"
  }, [_c('p'), _vm._v(" "), _c('ul', {
    staticClass: "recomList"
  }, _vm._l((_vm.recomList), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.protocol + '//h5.qxiu.com/room.html?roomid=' + item.roomId
      }
    }, [_c('img', {
      attrs: {
        "src": 'https://qiqi-resource-v6.qxiu.com' + JSON.parse(item.anchorPic)[0].slice(29)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "roomInfo"
    }, [_c('span', [_vm._v(_vm._s(item.anchorName.slice(0, 6)))]), _c('span', [_c('img', {
      staticClass: "viewer",
      attrs: {
        "src": __webpack_require__(13)
      }
    }), _vm._v(_vm._s(item.isOnline == 0 ? 0 : item.roomNum))])]), _vm._v(" "), _c('span', {
      staticClass: "live"
    })])])
  }), 0)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay"
  }, [_c('navtop', {
    attrs: {
      "index": ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v("￥" + _vm._s(_vm.orderRmb))]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("购买内容:" + _vm._s(_vm.orderRmb / 10) + "万齐齐豆")]), _vm._v(" "), _c('div', {
    staticClass: "selectPaytype"
  }, [_vm._v("选择支付方式")]), _vm._v(" "), (_vm.isWx) ? _c('a', {
    staticClass: "wx",
    on: {
      "click": function($event) {
        return _vm.pay(26)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("微信支付")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "zfb",
    on: {
      "click": function($event) {
        return _vm.pay(25)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("支付宝支付")])]), _vm._v(" "), (_vm.openBrowser) ? _c('div', {
    staticClass: "cover",
    on: {
      "click": function($event) {
        _vm.openBrowser = false
      }
    }
  }, [_vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("充值请点击右上角"), _c('br'), _vm._v("通过浏览器打开支付")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regist"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "phone"
  }, [_c('span', [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzImg),
      expression: "yzImg"
    }],
    staticClass: "yzImgInp",
    attrs: {
      "type": "text",
      "placeholder": "图形验证码"
    },
    domProps: {
      "value": (_vm.yzImg)
    },
    on: {
      "focus": _vm.checkPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzImg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "yzImg",
    attrs: {
      "src": _vm.yzImgSrc
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "chageImg",
    on: {
      "click": function($event) {
        _vm.yzImgSrc = _vm.yzImgSrc + '&v=' + Math.random()
      }
    }
  }, [_vm._v("换一张")])]), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请填写短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "focus": _vm.checkPhoneImg,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "getcodeBtn",
    attrs: {
      "disabled": !(_vm.phoneState && _vm.yzImgState & _vm.timer)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.timerstr))])]), _vm._v(" "), _c('div', {
    staticClass: "btnLogin",
    attrs: {
      "disabled": !(_vm.phoneState && _vm.codeState)
    },
    on: {
      "click": _vm.regist
    }
  }, [_vm._v("注册")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.outPop
    }
  }), _vm._v(" "), (_vm.popTips) ? _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        (_vm.popTips = false) && (_vm.tips = '')
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        (_vm.popTips = false) && (_vm.tips = '')
      }
    }
  }, [_vm._v("x")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("登录即代表您同意\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://client.qxiu.com/statement/privacy4.html"
    }
  }, [_vm._v("齐齐服务和隐私条款")])])
}]}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('齐齐直播'),
      expression: "'齐齐直播'"
    }],
    staticClass: "center"
  }, [_c('navtop'), _vm._v(" "), _c('div', {
    staticClass: "userInfo"
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg || '../../../static/zhubo.jpg'
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "userName"
  }, [(!_vm.fixednick) ? _c('a', [_vm._v(_vm._s(_vm.baseInfo.nick !== 'undefined' ? _vm.baseInfo.nick.slice(0, 8) : '齐齐牛人'))]) : _vm._e(), _vm._v(" "), (_vm.fixednick) ? _c('a', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uNick),
      expression: "uNick"
    }],
    staticClass: "fixednick-inp",
    attrs: {
      "type": "text",
      "placeholder": _vm.baseInfo.nick !== 'undefined' ? _vm.baseInfo.nick.slice(0, 6) : '',
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.uNick)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uNick = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "保存",
      "disabled": _vm.saveNick
    },
    on: {
      "click": _vm.subNick
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": _vm.cancelSubNick
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.fixednick) ? _c('i', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        _vm.fixednick = !_vm.fixednick
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uLabel"
  }, [_c('img', {
    attrs: {
      "src": _vm.leval ? ('https://static.qxiu.com/h5/img/static/nobility/' + (_vm.leval.nobility) + '.png') : ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userId"
  }, [_vm._v("ID : " + _vm._s(_vm.baseInfo.uid))])])]), _vm._v(" "), _c('ul', {
    staticClass: "funcList"
  }, [(_vm.showYe) ? _c('li', {
    staticClass: "zhye"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(96)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v("余额:")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toCharge
    }
  }, [_vm._v("充值")]), _vm._v(" "), _c('span', {
    staticClass: "ye"
  }, [_vm._v(_vm._s(_vm.qiqidou))])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mycare",
    on: {
      "click": _vm.toMycare
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(95)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.isxiaoxiong) ? _c('li', {
    staticClass: "bindPhone",
    on: {
      "click": _vm.toBindPhone
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(100)
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "jwdj"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(98)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "level"
  }, [_vm._v("等级")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": _vm.leval ? ('https://static.qxiu.com/h5/img/static/nobility/' + (_vm.leval.nobility) + '.png') : ''
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nobWrap"
  }, [_c('b', [_vm._v(_vm._s(_vm.curScore) + "/" + _vm._s(_vm.totalScore))]), _vm._v(" "), _c('i', {
    style: ('width: ' + _vm.curScore / _vm.totalScore * 6.4 + 'rem;')
  })]), _vm._v(" "), _c('p', [(_vm.leval.nobility != 28) ? _c('img', {
    attrs: {
      "src": _vm.leval ? ('https://static.qxiu.com/h5/img/static/nobility/' + (_vm.leval.nobility + 1) + '.png') : ''
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.kefuQQ = true
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(97)
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "authCode-item"
  }, [_c('div', {
    staticClass: "authCode-wrap"
  }, [_c('span', {
    staticClass: "authCode-label"
  }, [_vm._v("登陆码")]), _vm._v(" "), _c('div', {
    staticClass: "authCode-scroll"
  }, [_c('span', {
    staticClass: "authCode-text"
  }, [_vm._v(_vm._s(_vm.authCode))])])])]), _vm._v(" "), (_vm.isHideLogout && !_vm.isYouxi) ? _c('li', {
    staticClass: "logout"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(99)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    staticClass: "logout",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出账号")])])]) : _vm._e()]), _vm._v(" "), (_vm.kefuQQ) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v("请联系官方客服QQ:")]), _vm._v(" "), _c('p', [_vm._v("8007777777")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.kefuQQ = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.kefuQQ = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.logoutTips) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v("退出登录")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.confirmLogout
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.logoutTips = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.nickTips) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v(_vm._s(_vm.nickTipsCon))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.nickTips = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.nickTips = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v("我关注的")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v("绑定手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "bgKf"
  }, [_vm._v("联系客服")])])
}]}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginMode"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "userPortrait"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg || 'https://static.qxiu.com/h5/img/static/default2.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userNick || ''))]), _vm._v(" "), (_vm.wxLogin && !_vm.isxiaoxiong) ? _c('a', {
    staticClass: "btnLogin",
    attrs: {
      "href": 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26oemid%3D201' + _vm.hrefstr + '%26target%3dweblive%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
    }
  }, [_vm._v("微信登录")]) : _vm._e(), _vm._v(" "), (_vm.wxLogin && _vm.isxiaoxiong) ? _c('a', {
    staticClass: "btnLogin",
    attrs: {
      "href": 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3floginType%3dwechatGZHDL%26oemid%3D43' + _vm.hrefstr + '%26target%3dweblive%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
    }
  }, [_vm._v("微信登录")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dividLine"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.wxLogin ? '其他' : '') + "登录方式")]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.isxiaoxiong) ? _c('div', {
    staticClass: "loginEntry"
  }, [_c('a', {
    attrs: {
      "href": 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100717093&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3fjumpUrl%3dhttp%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fweblivelogin%26oemid%3D201' + _vm.hrefstr + '%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info'
    }
  }, [_c('i', {
    staticClass: "iconfont qq"
  }, [_vm._v("")])]), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": 'https://api.weibo.com/oauth2/authorize?client_id=1032315493&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dweibo%26oemid%3d201' + _vm.hrefstr + '%26target%3dweblive%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&scope=&'
    }
  }, [_c('i', {
    staticClass: "iconfont weibo"
  }, [_vm._v("")])]) : _vm._e(), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.phoneLogin
    }
  }, [_c('i', {
    staticClass: "iconfont phone"
  }, [_vm._v("")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isxiaoxiong) ? _c('div', {
    staticClass: "loginEntry"
  }, [_c('a', {
    attrs: {
      "href": 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101499693&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3ftarget%3dweblive%26loginType%3dqqDL%26oemid%3d43' + _vm.hrefstr + '%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info'
    }
  }, [_c('i', {
    staticClass: "iconfont qq"
  }, [_vm._v("")])]), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": 'https://api.weibo.com/oauth2/authorize?client_id=1032315493&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3ftarget%3dweblive%26loginType%3dweiboDL%26oemid%3d43' + _vm.hrefstr + '%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&scope=&'
    }
  }, [_c('i', {
    staticClass: "iconfont weibo"
  }, [_vm._v("")])]) : _vm._e(), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.phoneLogin
    }
  }, [_c('i', {
    staticClass: "iconfont phone"
  }, [_vm._v("")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.outPop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("登录即代表您同意\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://client.qxiu.com/statement/privacy4.html"
    }
  }, [_vm._v("齐齐服务和隐私条款")])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bindPhone"
  }, [_c('navtop', {
    attrs: {
      "index": 'bindPhone'
    }
  }), _vm._v(" "), (!_vm.hasBindPhone) ? _c('div', {
    staticClass: "con"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phoneNum",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgCodeWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzImg),
      expression: "yzImg"
    }],
    staticClass: "imgCodeNum",
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.yzImg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzImg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "codeImg",
    attrs: {
      "src": _vm.yzImgSrc
    },
    on: {
      "click": function($event) {
        _vm.yzImgSrc = _vm.yzImgSrc + '&v=' + Math.random()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "codeNum",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "disabled": !(_vm.phoneState && _vm.yzImgState & _vm.timer)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("\n                " + _vm._s(_vm.timerstr) + "\n            ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "请输入六位以上密码(可包含数字、字母或./-)"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bindBtn",
    attrs: {
      "disabled": !(_vm.phoneState && _vm.codeState && _vm.passwordState)
    },
    on: {
      "click": _vm.toBind
    }
  }, [_vm._v("\n            绑定\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.hasBindPhone) ? _c('div', {
    staticClass: "hasBind"
  }, [_c('p', {
    staticClass: "phone"
  }, [_vm._v("\n            " + _vm._s(_vm.hasBindPhone.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3")) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("绑定手机号可用于此账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "changeBtn",
    on: {
      "click": _vm.toChangePhone
    }
  }, [_vm._v("更改")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [(_vm.showDown && _vm.showLabel && _vm.index == 0 && !_vm.isxiaoxiong) ? _c('div', {
    staticClass: "download dataReport",
    attrs: {
      "data-place": "34"
    },
    on: {
      "click": _vm.loadDown
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(94)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("下载")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.closeLabel
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "describ"
  }, [_c('p', [_vm._v("更精彩 更清晰 更流畅")]), _vm._v(" "), _c('span', [_vm._v("进入APP直播间获得更多体验")])])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('齐齐直播'),
      expression: "'齐齐直播'"
    }],
    staticClass: "dt"
  }, [_c('navtop', {
    attrs: {
      "index": 'dating'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('i', {
    staticClass: "iconfont",
    on: {
      "click": _vm.showSearch
    }
  }, [_vm._v("")]), _vm._v(" "), (_vm.searchShow) ? _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "searchCon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchId),
      expression: "searchId"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.searchShow),
      expression: "searchShow"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入6位房间号"
    },
    domProps: {
      "value": (_vm.searchId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.searchRoom
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(102)
    }
  })])]), _vm._v(" "), _c('i')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabWrap"
  }, [_c('ul', [_c('li', {
    class: {
      cur: _vm.navIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 1
      }
    }
  }, [_c('a', [_vm._v("大厅")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 5
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 5
      }
    }
  }, [_c('a', [_vm._v("女神")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 2
      }
    }
  }, [_c('a', [_vm._v("新人")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 3
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 3
      }
    }
  }, [_c('a', [_vm._v("好声音")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 4
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 4
      }
    }
  }, [_c('a', [_vm._v("型男")])])])]), _vm._v(" "), (_vm.popTips || _vm.tips.con) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips.con))]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.confirmTips
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.closeTips
    }
  }, [_vm._v("x")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "anchorList",
    style: ('height:' + _vm.scrollHeight + ';overflow:scroll;-webkit-overflow-scrolling: touch;')
  }, [_c('ul', [_vm._l((_vm.showList), function(item, index) {
    return (index < _vm.lazyImg) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.checkLogin(item.roomId)
        }
      }
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": typeof item.anchorPic == 'object' ? ('https://qiqi-resource-v6.qxiu.com' + item.anchorPic[0].slice(29)) : ('https://qiqi-resource-v6.qxiu.com' + JSON.parse(item.anchorPic)[0].slice(29))
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.subString(item.anchorName, 9, true))), _c('span', [_c('img', {
      staticClass: "viewer",
      attrs: {
        "src": __webpack_require__(13)
      }
    }), _vm._v(_vm._s(item.roomNum))])]), _vm._v(" "), (item.happyPk == 0) ? _c('span', {
      staticClass: "label"
    }) : _vm._e(), _vm._v(" "), (item.happyPk != 0) ? _c('span', {
      staticClass: "labelPk"
    }) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.loadingMore) ? _c('li', {
    staticClass: "loadingMore"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(23)
    }
  }), _vm._v(" "), _c('span', [_vm._v("加载中..")])]) : _vm._e()], 2)]), _vm._v(" "), _c(_vm.curview, {
    tag: "component"
  }), _vm._v(" "), (_vm.loadingImg) ? _c('div', {
    staticClass: "loadingImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(23)
    }
  }), _vm._v(" "), _c('span', [_vm._v("加载中..")])]) : _vm._e(), _vm._v(" "), (_vm.isxiaoxiong) ? _c('div', {
    staticClass: "downEntry",
    style: ('background:url(https://static.qxiu.com/h5/static/down3.png);background-size:4.68rem 2.08rem;display:' + (!_vm.isAndroid && _vm.isYouxi ? 'none' : 'block')),
    on: {
      "click": _vm.download
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isxiaoxiong) ? _c('div', {
    staticClass: "downEntry2",
    on: {
      "click": _vm.download
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isYouxi) ? _c('div', {
    staticClass: "backGame",
    on: {
      "click": _vm.backGame
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowTgy) ? _c('div', {
    staticClass: "tg202102",
    on: {
      "click": function($event) {
        _vm.isShowTgy = false
      }
    }
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": _vm.toRegist
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('navtop'), _vm._v(" "), _c('ul', {
    staticClass: "resList"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.checkLogin(_vm.roomInfo.roomId)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.roomInfo.roomPic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.roomInfo.roomName))]), _vm._v(" "), _c('span', [_vm._v("房间ID:" + _vm._s(_vm.roomInfo.roomid || _vm.roomInfo.roomId))])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paySucc"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("支付成功")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toRecharge
    }
  }, [_vm._v(" 确定" + _vm._s(_vm.roomid))])])])
},staticRenderFns: []}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toCenter
    }
  }, [_c('img', {
    staticClass: "user",
    attrs: {
      "src": _vm.userImg
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tologin",
    domProps: {
      "innerHTML": _vm._s(!_vm.isLogin ? '请点击登录' : _vm.HTMLEscape(_vm.userNick.slice(0, 8)))
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index != 'dating' && _vm.index != 'bindPhone'),
      expression: "index!='dating'&&index!='bindPhone'"
    }],
    staticClass: "toIndex",
    on: {
      "click": _vm.toDating
    }
  }, [_c('img', {
    staticClass: "charge",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.showRoomEntry ? '返回房间' : '返回大厅'))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index == 'bindPhone'),
      expression: "index=='bindPhone'"
    }],
    staticClass: "toIndex",
    on: {
      "click": _vm.toCenter
    }
  }, [_c('img', {
    staticClass: "charge",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('span', [_vm._v("  返回")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index == 'dating'),
      expression: "index=='dating'"
    }],
    staticClass: "mySub",
    on: {
      "click": _vm.toCare
    }
  }, [_c('img', {
    staticClass: "charge",
    attrs: {
      "src": __webpack_require__(101)
    }
  }), _vm._v(" "), _c('span', [_vm._v("我关注的")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index == 'dating'),
      expression: "index=='dating'"
    }],
    staticClass: "devide"
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRecharge),
      expression: "showRecharge"
    }],
    staticClass: "charge-wrap",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toRecharge
    }
  }, [_c('span', [_vm._v("充值")])])])
},staticRenderFns: []}

/***/ })
],[45]);


// WEBPACK FOOTER //
// static/js/app.9188b0e3edcdc8e69f9d.js